import $ from 'jquery';
import lodashfilter from 'lodash/filter';
import lodashEqual from 'lodash/isEqual';
var Config: any = require('../Config.json');

var self = this;
const userRights = {
    checkVisibility: (params: string) => {
        var visibilitySetting = 'show';
        var userRights: any = sessionStorage.getItem('userRights');
        var rights = JSON.parse(userRights);
        if (rights != null && rights != undefined) {
            var rightValue = [parseInt(params)];
            var isValueExits = $.inArray(rightValue.toString(), rights);
            if (isValueExits == -1) {
                visibilitySetting = 'hidden';
            }
        }

        return visibilitySetting;
    },
    checkMenuItemVisibility: (rightId: string) => {
        var visibilitySetting = [];
        var userRights: any = sessionStorage.getItem('userRights');
        var rights = JSON.parse(userRights);
        if (rights != null && rights != undefined) {
            var rightValue = [parseInt(rightId)];
            var isValueExits = $.inArray(rightValue.toString(), rights);
            if (isValueExits == -1) {
                visibilitySetting.push('hidden');
            }
        }

        return visibilitySetting;
    },
    //RCNG-1478
    checkMenuItemVisibilityGT1030: (params, contextMenuItem: string, rightId: string) => {
        var visibilitySetting = [];
        var visible = true;
        var userRights: any = sessionStorage.getItem('userRights');
        var rights = JSON.parse(userRights);
        if (rights != null && rights != undefined) {
            var rightValue = [parseInt(rightId)];
            var isValueExits = $.inArray(rightValue.toString(), rights);
            if (isValueExits == -1) {
                visible = false;
                visibilitySetting.push('hidden');
            }
        }
        if (visible) {
            var selectedRows = params.api.getSelectedRows();
            var selectedUserData = [];
            var visibilitySetting = [];
            if (selectedRows.length != 0) {
                var selected = params.api.getFocusedCell();
                var selectedRow = params.api.getRowNode(selected.rowIndex);
                selectedRows.forEach(function (selectedRow, index) {
                    selectedUserData.push(selectedRow);
                });
            }
            var isGT1030Found;
            isGT1030Found = selectedUserData.filter(x => x.AssetState == 'A' && x.DeviceType != null && x.DeviceType.trim() == 'GT1030');
            if (isGT1030Found.length > 0) {
                visibilitySetting.push('hidden');
            }
        }
        else
            return visibilitySetting;
        return visibilitySetting;
    },

    checkMenuItemResetPasswordVisibility: (params, rightId: string) => {
        var visibilitySetting = [];
        var selectedUserData = [];
        var userRights: any = sessionStorage.getItem('userRights');
        var checkOktaUser: any = JSON.parse(sessionStorage.getItem('UserInfo')).SSOSignInType;
        var selectedRows = params.api.getSelectedRows();
        if (selectedRows.length != 0) {
            var selected = params.api.getFocusedCell();
            var selectedRow = params.api.getRowNode(selected.rowIndex);
            selectedRows.forEach(function (selectedRow, index) {
                selectedUserData.push(selectedRow);
            });
        }

        if (checkOktaUser == "Okta" && (selectedUserData[0].OKTASignInOverrideOption == "A" || selectedUserData[0].OKTASignInOverrideOption == "R")) {
            visibilitySetting.push('hidden');
            return visibilitySetting;
        }
        var rights = JSON.parse(userRights);
        if (rights != null && rights != undefined) {
            var rightValue = [parseInt(rightId)];
            var isValueExits = $.inArray(rightValue.toString(), rights);
            if (isValueExits == -1) {
                visibilitySetting.push('hidden');
            }
        }

        return visibilitySetting;
    },
    checkOktaUserMenuVisiblity: (params, rightId: string) => {
        var selectedRows = params.api.getSelectedRows();
        //var customerTypeCd = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerTypeCd;
        var selectedUserData = [];
        var visibilitySetting = [];
        if (selectedRows.length != 0) {
            var selected = params.api.getFocusedCell();
            var selectedRow = params.api.getRowNode(selected.rowIndex);
            selectedRows.forEach(function (selectedRow, index) {
                selectedUserData.push(selectedRow);
            });
        }
        if (selectedUserData.length > 1) {
            visibilitySetting.push('hidden');
        }
        else if (selectedUserData.length == 1) {
            var userRights: any = sessionStorage.getItem('userRights');
            var rights = JSON.parse(userRights);
            if (rights != null && rights != undefined) {
                var rightValue = [parseInt(rightId)];
                var isValueExits = $.inArray(rightValue.toString(), rights);
                if (isValueExits == -1 || selectedUserData[0].OKTASignInOverrideOption == null || selectedUserData[0].OKTASignInOverrideOption.trim() == '') {
                    visibilitySetting.push('hidden');
                }
            }
        }

        return visibilitySetting;
    },
    //RCNG-1229-s
    checkAzureUserMenuVisiblity: (params, rightId: string) => {
        var selectedRows = params.api.getSelectedRows();
        //var customerTypeCd = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerTypeCd;
        var selectedUserData = [];
        var visibilitySetting = [];
        if (selectedRows.length != 0) {
            var selected = params.api.getFocusedCell();
            var selectedRow = params.api.getRowNode(selected.rowIndex);
            selectedRows.forEach(function (selectedRow, index) {
                selectedUserData.push(selectedRow);
            });
        }
        if (selectedUserData.length > 1) {
            visibilitySetting.push('hidden');
        }
        else if (selectedUserData.length == 1) {
            var userRights: any = sessionStorage.getItem('userRights');
            var rights = JSON.parse(userRights);
            if (rights != null && rights != undefined) {
                var rightValue = [parseInt(rightId)];
                var isValueExits = $.inArray(rightValue.toString(), rights);
                if (isValueExits == -1 || selectedUserData[0].AzureSignInOverrideOption == null ||
                    selectedUserData[0].AzureSignInOverrideOption == '') {
                    visibilitySetting.push('hidden');
                }
            }
        }

        return visibilitySetting;
    },
    //RCNG-1229-E
    checkMenuItemDisabledForChassis(params, cmdStr) {
        var isDisabled = false;
        var selectedChassisData = [];
        var selectedRows = params.api.getSelectedRows();

        if (selectedRows.length != 0) {
            var selected = params.api.getFocusedCell();
            var selectedRow = params.api.getRowNode(selected.rowIndex);
            selectedRows.forEach(function (selectedRow, index) {
                selectedChassisData.push(selectedRow);
            });
        }
        if (selectedChassisData.length > 1) {
            if (cmdStr === "CurrentDetails" || cmdStr === "ThirdPartyAccess") {
                isDisabled = true;
            }
        } else if (selectedChassisData.length == 1) {
            if (cmdStr === "UnAssign" || cmdStr === "Assign") {
                if (selectedChassisData != null && selectedChassisData != undefined) {
                    if (selectedChassisData[0].customername != "") {
                        if (selectedChassisData[0].customername === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName) {
                            if (cmdStr === "UnAssign") {
                                isDisabled = true;
                            }
                        }
                        //else { //RCNG-1175
                        //    if (cmdStr === "Assign") {
                        //        isDisabled = true;
                        //    }
                        //}
                    }
                }
            }

        }
        return isDisabled;
    },
    checkMenuItemDisabledForDry(params, cmdStr) {
        var isDisabled = false;
        var selectedDryData = [];
        var selectedRows = params.api.getSelectedRows();

        if (selectedRows.length != 0) {
            var selected = params.api.getFocusedCell();
            var selectedRow = params.api.getRowNode(selected.rowIndex);
            selectedRows.forEach(function (selectedRow, index) {
                selectedDryData.push(selectedRow);
            });
        }
        if (selectedDryData.length > 1) {
            if (cmdStr === "CurrentDetails" || cmdStr === "ThirdPartyAccess") {
                isDisabled = true;
            }
        } else if (selectedDryData.length == 1) {
            if (cmdStr === "UnAssign" || cmdStr === "Assign") {
                if (selectedDryData != null && selectedDryData != undefined) {
                    if (selectedDryData[0].customername != "") {
                        if (selectedDryData[0].customername === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName) {
                            if (cmdStr === "UnAssign") {
                                isDisabled = true;
                            }
                        }
                        //else { //RCNG-1175
                        //    if (cmdStr === "Assign") {
                        //        isDisabled = true;
                        //    }
                        //}
                    }
                }
            }

        }
        return isDisabled;
    },
    checkMenuItemDisabledForGenset(params, cmdStr) {
        var isDisabled = false;
        var selectedGensetData = [];
        var selectedRows = params.api.getSelectedRows();

        if (selectedRows.length != 0) {
            var selected = params.api.getFocusedCell();
            var selectedRow = params.api.getRowNode(selected.rowIndex);
            selectedRows.forEach(function (selectedRow, index) {
                selectedGensetData.push(selectedRow);
            });
        }
        if (selectedGensetData.length > 1) {
            if (cmdStr === "CurrentDetails" || cmdStr === "ThirdPartyAccess") {
                isDisabled = true;
            }
        } else if (selectedGensetData.length == 1) {
            if (cmdStr === "UnAssign" || cmdStr === "Assign") {
                if (selectedGensetData != null && selectedGensetData != undefined) {
                    if (selectedGensetData[0].CustomerName != "") {
                        if (selectedGensetData[0].CustomerName === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName) {
                            if (cmdStr === "UnAssign") {
                                isDisabled = true;
                            }
                        }
                        //else {//RCNG-1175
                        //    if (cmdStr === "Assign") {
                        //        isDisabled = true;
                        //    }
                        //}
                    }
                }
            }

        }
        //var forwardCommandParam = JSON.stringify(selectedGensetData);
        //var url = Config.ApiBaseUrl + '/api/ReeferStatus/GetAssetAssigned3rdParty';
        //var request = RCUtils.FetchRequest(url, { method: 'POST', body: forwardCommandParam, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //fetch(request)
        //    .then(RCUtils.handleError)
        //    .then(response => response.json() as Promise<string>)
        //    .then(data => {
        //        if (data == "assigned") {
        //            if (cmdStr === "Assign") {
        //                isDisabled = true;
        //            }
        //        }
        //        else if (data == "unassigned") {
        //            if (cmdStr === "UnAssign") {
        //                isDisabled = true;
        //            }
        //        }
        //        else {
        //            if (cmdStr === "ThirdPartyAccess") {
        //                isDisabled = true;
        //            }              
        //        }
        //    });
        return isDisabled;
    },
    checkMenuItemVisibilitybyData: (rightId: string, params, cmdStr, refControllertypes: any) => {
        var dCXDownloads;
        dCXDownloads = JSON.parse(sessionStorage.getItem('customerDetails')).DCXDownloads;
        var tripWISEReport;
        tripWISEReport = JSON.parse(sessionStorage.getItem('customerDetails')).TripWISEreport;
        var visibilitySetting = [];
        var hide = false;
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });
        var isDeviceTypeFound = 0;
        var isCT4Found = 0;
        var isFromVessel = 0;
        var isSekstantFound = 0;
        var isLynxFound = 0;
        var isMPModelFound = 0;
        var isCT35ML5Found = 0;
        var isCT36ML5Found = 0;
        $.each(selectedReeferData, function (i, val) {
            if (val.DeviceType != null && val.DeviceType != undefined) {
                if (val.DeviceType.toString().trim() == 'CT5000') {
                    isDeviceTypeFound = isDeviceTypeFound + 1;
                }
                if (val.DeviceType.toString().trim() == 'CT4000') {
                    isCT4Found = isCT4Found + 1;
                    if (val.VesselCd != undefined && val.VesselCd != null)
                        isFromVessel = isFromVessel + 1;
                }
                if (val.DeviceType.toString().trim() == 'Sekstant') {
                    isSekstantFound = isSekstantFound + 1;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'TRIPLINK') {
                    isLynxFound = isLynxFound + 1;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'CT3500') {//IOT Token ML5 on CT 35/36
                    var controllerDesc = "";
                    var controllertype = lodashfilter(refControllertypes, function (item) {
                        return item.ControllerTypeCd === val.ControllerTypeCd;
                    });
                    if (controllertype.length > 0 && controllertype != null) {
                        controllerDesc = controllertype[0].ControllerDesc;
                    }
                    if (controllerDesc == 'ML5')
                        isCT35ML5Found = isCT35ML5Found + 1;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'CT3600') {//IOT Token ML5 on CT 35/36
                    var controllerDesc = "";
                    var controllertype = lodashfilter(refControllertypes, function (item) {
                        return item.ControllerTypeCd === val.ControllerTypeCd;
                    });
                    if (controllertype.length > 0 && controllertype != null) {
                        controllerDesc = controllertype[0].ControllerDesc;
                    }
                    if (controllerDesc == 'ML5')
                        isCT36ML5Found = isCT36ML5Found + 1;
                }
            }
            if (val.ReeferOEMTypeCd != null && val.ReeferOEMTypeCd != undefined) {
                if (val.ReeferOEMTypeCd.trim() == 'T') {
                    if (val.UnitTypeCd != null && val.UnitTypeCd != undefined && val.UnitTypeCd != '') {
                        if (val.UnitTypeCd.trim() == 'TA' || val.UnitTypeCd.trim() == 'TM' || val.UnitTypeCd.trim() == 'TR') {
                            isMPModelFound = isMPModelFound + 1;
                        }
                    }
                }
            }
        });
        var isGuestFound;
        isGuestFound = selectedReeferData.filter(row => row.DeviceConfig == true);


        if (isCT4Found > 0) {
            var eligibleForShow = ['DeviceResetToDefaults', 'Ping', 'DeviceReset', 'O2', 'StartDefrost', 'ChgDefrostInterval', 'RebootReeferController', 'ChangeReeferID', 'GetAssetId', 'EnableDoorSensor'];
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['SynctoDevice', 'ClockSyncSettings', 'ControlledAtmosphere', 'SetDataLogInterval', 'Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest'
                , 'StopPre-Trip', 'Update', 'Verify', 'MultipleSetpoints', 'AutomaticColdTreatment', 'ChangeZigbeeConfigSettings',
                'AssetConfiguration', 'Get-FreshAirType', 'Set-FreshAirType', 'ChilledandCA'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }
            var eligibleTWReportForShowHide = ['GetTripWISEReport', 'ShowTripWISEReport'];
            if (eligibleTWReportForShowHide.indexOf(cmdStr) !== -1) {
                if (tripWISEReport == true)
                    hide = false;
                else
                    hide = true;
            }
        }
        if (isDeviceTypeFound > 0) {
            var eligibleForShow = ['Ping', 'DeviceReset', 'O2', 'StartDefrost', 'ChgDefrostInterval', 'RebootReeferController', 'ChangeReeferID'];//, 'GetAssetId'
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['SetReportingInterval', 'DeviceResetToDefaults', 'SynctoDevice', 'ClockSyncSettings', 'ControlledAtmosphere', 'GetDataLog', 'SetDataLogInterval', 'Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest'
                , 'StopPre-Trip', 'ScheduledPre-Trip', 'GetPre-TripResults', 'ShowPre-TripResults', 'Update', 'Verify', 'MultipleSetpoints', 'AutomaticColdTreatment', 'ChangeZigbeeConfigSettings', 'DeviceConfiguration',
                'AssetConfiguration', 'Get-FreshAirType', 'Set-FreshAirType', 'ChilledandCA', 'GetAssetId', 'GetTripWISEReport', 'ShowTripWISEReport', 'EnableDoorSensor'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }
        }
        if (isLynxFound > 0) {
            var eligibleForShow = ['O2', 'CO2', 'Humidity', 'StartDefrost', 'Temperature', 'ChgDefrostInterval',
                'RebootReeferController', 'ChangeReeferID', 'GetDataLog', 'ShowPre-TripResults'];
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['DeviceResetToDefaults', 'Ping', 'DeviceReset', 'SynctoDevice', 'ClockSyncSettings', 'ControlledAtmosphere',
                'SetDataLogInterval', 'Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'StopPre-Trip', 'Update',
                'Verify', 'MultipleSetpoints', 'AutomaticColdTreatment', 'ChangeZigbeeConfigSettings',
                'AssetConfiguration', 'DeviceConfiguration', 'Get-FreshAirType', 'Set-FreshAirType', 'FreshAirType', 'ChilledandCA', 'GetAssetId',
                'EnableDoorSensor', 'GuestReeferconfiguration', 'AssignPANId', 'ScheduledPre-Trip', 'GetPre-TripResults'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }
            var eligibleTWReportForShowHide = ['GetTripWISEReport', 'ShowTripWISEReport'];
            if (eligibleTWReportForShowHide.indexOf(cmdStr) !== -1) {
                if (tripWISEReport == true)
                    hide = false;
                else
                    hide = true;
            }
        }
        if (isCT35ML5Found > 0) {
            var eligibleForShow = ['Humidity','StartDefrost', 'ChgDefrostInterval'];//, 'GetAssetId'
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['Ping','AssignPANId', 'DeviceReset', 'RebootReeferController', 'ChangeReeferID', 'O2','CO2','SetReportingInterval', 'DeviceResetToDefaults', 'SynctoDevice', 'ClockSyncSettings', 'ControlledAtmosphere', 'GetDataLog', 'SetDataLogInterval', 'Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest'
                , 'StopPre-Trip', 'ScheduledPre-Trip', 'GetPre-TripResults', 'ShowPre-TripResults', 'Update', 'Verify', 'MultipleSetpoints', 'AutomaticColdTreatment', 'ChangeZigbeeConfigSettings', 'DeviceConfiguration',
                'AssetConfiguration', 'Get-FreshAirType', 'Set-FreshAirType', 'ChilledandCA', 'GetAssetId', 'GetTripWISEReport', 'ShowTripWISEReport', 'EnableDoorSensor'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }
        }
        if (isCT36ML5Found > 0) {
            var eligibleForShow = ['Humidity', 'StartDefrost', 'ChgDefrostInterval', 'GetDataLog'];//, 'GetAssetId'
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['Ping', 'AssignPANId', 'DeviceReset', 'RebootReeferController', 'ChangeReeferID', 'O2', 'CO2', 'SetReportingInterval', 'DeviceResetToDefaults', 'SynctoDevice', 'ClockSyncSettings', 'ControlledAtmosphere', 'SetDataLogInterval', 'Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest'
                , 'StopPre-Trip', 'ScheduledPre-Trip', 'GetPre-TripResults', 'ShowPre-TripResults', 'Update', 'Verify', 'MultipleSetpoints', 'AutomaticColdTreatment', 'ChangeZigbeeConfigSettings', 'DeviceConfiguration',
                'AssetConfiguration', 'Get-FreshAirType', 'Set-FreshAirType', 'ChilledandCA', 'GetAssetId', 'GetTripWISEReport', 'ShowTripWISEReport', 'EnableDoorSensor'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }
        }
        if (isSekstantFound > 0 && selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S')) {
            var eligibleForShow = ['O2', 'CO2', 'Humidity', 'GetDataLog'];
            if (eligibleForShow.indexOf(cmdStr) !== -1)
                hide = false;
            else
                hide = true;
        }

        var customerTypeCd = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerTypeCd;
        var eligibleForHide = ['DeviceConfiguration', 'EnableDoorSensor']; // WI 26604 added 'EnableDoorSensor' access only for SO User
        if (eligibleForHide.indexOf(cmdStr) !== -1 && customerTypeCd != "SO") {
            hide = true;
        }
        if (selectedReeferData.length > 1) {
            if (selectedReeferData.length == selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C').length) {
                if (isGuestFound.length == selectedReeferData.length) {
                    if (cmdStr === 'Humidity') {
                        hide = true;
                    }
                }
            }
            if (selectedReeferData.length == selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length) {
                var eligibleForHide = ['O2', 'CO2', 'CAFull', 'CAFunctionTest'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            else if (selectedReeferData.length == selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length) {
                if (isSekstantFound > 0) {
                    var eligibleForHide = ['Chilled', 'Frozen', 'CA', 'ChilledandCA'];
                    if (eligibleForHide.indexOf(cmdStr) !== -1) {
                        hide = true;
                    }
                }
                else {
                    var eligibleForHide = ['Chilled', 'O2', 'CO2', 'Frozen', 'CA', 'ChilledandCA'];
                    if (eligibleForHide.indexOf(cmdStr) !== -1) {
                        hide = true;
                    }
                }
            }
            else if ((selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length > 0) && (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length > 0) && selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length)) {
                if (isSekstantFound > 0) {
                    var eligibleForShow = ['Humidity', 'GetDataLog'];
                    if (eligibleForShow.indexOf(cmdStr) !== -1) {
                        hide = false;
                    }
                    var eligibleForHide = ['Chilled', 'O2', 'CO2'];
                    if (eligibleForHide.indexOf(cmdStr) !== -1) {
                        hide = true;
                    }
                }
                else {
                    var eligibleForHide = ['Chilled', 'O2', 'CO2'];
                    if (eligibleForHide.indexOf(cmdStr) !== -1) {
                        hide = true;
                    }
                }
            }
            else {
                var eligibleForHide = ['ControlledAtmosphere'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }

            }

            if (selectedReeferData.length == selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length) {
                var eligibleForShow = ['CAFull', 'CAFunctionTest'];
                if (eligibleForShow.indexOf(cmdStr) !== -1) {
                    hide = false;
                }
            }
            if (selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C' && row.DeviceConfig == true).length)) {

                if (isSekstantFound > 0 && (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length == isSekstantFound && selectedReeferData.length == selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length)) {
                    var eligibleForShow = ['O2', 'CO2'];
                    if (eligibleForShow.indexOf(cmdStr) !== -1) {
                        hide = false;
                    }
                }
                else {
                    var eligibleForHide = ['O2', 'CO2'];
                    if (eligibleForHide.indexOf(cmdStr) !== -1) {
                        hide = true;
                    }
                }
            }
            if (selectedReeferData.length == selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C' && row.ReeferOEMTypeCd && row.DeviceConfig == true).length) {
                var eligibleForHide = ['SetDataLogInterval'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length > 0) {
                var eligibleForHide = ['ChgDefrostInterval'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C').length)) {
                var eligibleForHide = ['Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'ChilledandCA'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if ((selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C').length > 0) && (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length > 0) && selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length)) {
                var eligibleForHide = ['Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'ChilledandCA'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if ((selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length > 0) && (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length > 0) && selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length)) {
                var eligibleForHide = ['Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'ChilledandCA'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            else if ((selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length > 0) && (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'T').length > 0) && selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'T').length)) {
                var eligibleForHide = ['Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'ChilledandCA'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            else if ((selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C').length > 0) && (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'T').length > 0) && selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'T').length)) {
                var eligibleForHide = ['Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'ChilledandCA'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            else if ((selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length > 0) && (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'T').length > 0) && selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'T').length)) {
                var eligibleForHide = ['Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'ChilledandCA'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            else if ((selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length > 0) && (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C').length > 0) && selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C').length)) {
                var eligibleForHide = ['Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'ChilledandCA'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (selectedReeferData.length != (isCT4Found) || isFromVessel > 0) {//isDeviceTypeFound +
                var eligibleForHide = ['GetAssetId']
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (selectedReeferData.length != isCT4Found) {
                var eligibleForHide = ['GetTripWISEReport', 'ShowTripWISEReport', 'EnableDoorSensor']
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }

            if (selectedReeferData.length != isLynxFound) {
                var eligibleForHide = ['GetTripWISEReport', 'ShowTripWISEReport']
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (selectedReeferData.length == isLynxFound) {
                var eligibleForShow = ['GetTripWISEReport', 'ShowTripWISEReport']
                if (eligibleForShow.indexOf(cmdStr) !== -1) {
                    hide = false;
                }
            }
        }
        else {
            var ReeferOEMTypeCd = "";
            if (selectedReeferData[0].ReeferOEMTypeCd != null)
                ReeferOEMTypeCd = selectedReeferData[0].ReeferOEMTypeCd;
            var IsGuest = selectedReeferData[0].DeviceConfig;
            if (ReeferOEMTypeCd.trim() == 'D') {
                var eligibleForHide = ['O2', 'CO2', 'CAFull', 'CAFunctionTest'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            else if (ReeferOEMTypeCd.trim() == 'S') {
                if (isSekstantFound > 0) {
                    var eligibleForHide = ['Chilled', 'ChgDefrostInterval', 'Frozen', 'CA', 'ChilledandCA'];
                    if (eligibleForHide.indexOf(cmdStr) !== -1) {
                        hide = true;
                    }
                }
                else {
                    var eligibleForHide = ['O2', 'CO2', 'Chilled', 'ChgDefrostInterval', 'Frozen', 'CA', 'ChilledandCA'];
                    if (eligibleForHide.indexOf(cmdStr) !== -1) {
                        hide = true;
                    }
                }
            }
            if ((ReeferOEMTypeCd.trim() == 'C' && IsGuest) || (ReeferOEMTypeCd.trim() == 'S') || (ReeferOEMTypeCd.trim() == 'D')) {

                if (!(isSekstantFound > 0 && ReeferOEMTypeCd.trim() == 'S')) {
                    var eligibleForHide = ['O2', 'CO2'];
                    if (eligibleForHide.indexOf(cmdStr) !== -1) {
                        hide = true;
                    }
                }
            }
            if (ReeferOEMTypeCd.trim() == 'C' && IsGuest) {
                var eligibleForHide = ['SetDataLogInterval'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (ReeferOEMTypeCd.trim() == 'C' || ReeferOEMTypeCd.trim() == 'T') {
                var eligibleForHide = ['ControlledAtmosphere', 'CAFull', 'CAFunctionTest', 'Frozen', 'CA', 'ChilledandCA', 'Chilled'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (!(isCT4Found > 0)) {//isDeviceTypeFound > 0 ||
                var eligibleForHide = ['GetAssetId']
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (isFromVessel > 0) {
                var eligibleForHide = ['GetAssetId']
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (!(isCT4Found > 0)) {
                var eligibleForHide = ['GetTripWISEReport', 'ShowTripWISEReport', 'EnableDoorSensor']
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (!(isLynxFound > 0)) {
                var eligibleForHide = ['GetTripWISEReport', 'ShowTripWISEReport']
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (isLynxFound > 0) {
                var eligibleForShow = ['GetTripWISEReport', 'ShowTripWISEReport']
                if (eligibleForShow.indexOf(cmdStr) !== -1) {
                    hide = false;
                }
            }
        }

        //RCNG - 3641
        //if (cmdStr === 'ShowTripWISEReport' || cmdStr === 'GetTripWISEReport') {
        //    if (tripWISEReport == true) {
        //        var supportedDeviceTypes = ["CT4000", "TripLink"];
        //        if (selectedReeferData.length > 1) {
        //            var result = selectedReeferData.filter(x => x.DeviceType.trim() == "CT4000" || x.DeviceType.trim() == "TripLink");
        //            if (selectedReeferData.length != result.length)
        //                hide = true;
        //            else
        //                hide = false;
        //        }
        //        else {
        //            if (selectedReeferData[0].DeviceType.trim() == "CT4000" || selectedReeferData[0].DeviceType.trim() == 'TripLink')
        //                hide = false;
        //            else
        //                hide = true;
        //        }
        //    }
        //}

        if (isMPModelFound > 0) {
            var eligibleForHide = ['SynctoDevice', 'SetDataLogInterval'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }
            //else { // Commented else code for WI 26604 
            //    hide = false; 
            //}
        }

        var userRights: any = sessionStorage.getItem('userRights');
        var rights = JSON.parse(userRights);
        if (rights != null && rights != undefined) {
            var rightValue = [parseInt(rightId)];
            var isValueExits = $.inArray(rightValue.toString(), rights);
            if (isValueExits == -1) {
                visibilitySetting.push('hidden');
            }
            if (isValueExits != -1 && hide) {
                visibilitySetting.push('hidden');
            }
        }
        return visibilitySetting;
    },
    checkMenuItemVisibilitybyDataForTDD: (rightId: string, params, cmdStr, refControllertypes: any, ShowTDDForCT36ML5: boolean, ShowTDDForCT35ML5: boolean) => {
        var dCXDownloads;
        dCXDownloads = JSON.parse(sessionStorage.getItem('customerDetails')).DCXDownloads;
        var tripWISEReport;
        tripWISEReport = JSON.parse(sessionStorage.getItem('customerDetails')).TripWISEreport;
        var visibilitySetting = [];
        var hide = false;
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });
        var isDeviceTypeFound = 0;
        var isCT4Found = 0;
        var isFromVessel = 0;
        var isSekstantFound = 0;
        var isLynxFound = 0;
        var isMPModelFound = 0;
        var isCT35ML5Found = 0;
        var isCT36ML5Found = 0;
        $.each(selectedReeferData, function (i, val) {
            if (val.DeviceType != null && val.DeviceType != undefined) {
                if (val.DeviceType.toString().trim() == 'CT5000') {
                    isDeviceTypeFound = isDeviceTypeFound + 1;
                }
                if (val.DeviceType.toString().trim() == 'CT4000') {
                    isCT4Found = isCT4Found + 1;
                    if (val.VesselCd != undefined && val.VesselCd != null)
                        isFromVessel = isFromVessel + 1;
                }
                if (val.DeviceType.toString().trim() == 'Sekstant') {
                    isSekstantFound = isSekstantFound + 1;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'TRIPLINK') {
                    isLynxFound = isLynxFound + 1;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'CT3500' || val.DeviceType.toString().trim().toUpperCase() == 'CT3600') {//IOT Token ML5 on CT 35/36
                    var controllerDesc = "";
                    var controllertype = lodashfilter(refControllertypes, function (item) {
                        return item.ControllerTypeCd === val.ControllerTypeCd;
                    });
                    if (controllertype.length > 0 && controllertype != null) {
                        controllerDesc = controllertype[0].ControllerDesc;
                    }
                    if (controllerDesc == 'ML5')
                        isCT35ML5Found = isCT35ML5Found + 1;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'CT3600') {//IOT Token ML5 on CT 35/36
                    var controllerDesc = "";
                    var controllertype = lodashfilter(refControllertypes, function (item) {
                        return item.ControllerTypeCd === val.ControllerTypeCd;
                    });
                    if (controllertype.length > 0 && controllertype != null) {
                        controllerDesc = controllertype[0].ControllerDesc;
                    }
                    if (controllerDesc == 'ML5')
                        isCT36ML5Found = isCT36ML5Found + 1;
                }
            }
            if (val.ReeferOEMTypeCd != null && val.ReeferOEMTypeCd != undefined) {
                if (val.ReeferOEMTypeCd.trim() == 'T') {
                    if (val.UnitTypeCd != null && val.UnitTypeCd != undefined && val.UnitTypeCd != '') {
                        if (val.UnitTypeCd.trim() == 'TA' || val.UnitTypeCd.trim() == 'TM' || val.UnitTypeCd.trim() == 'TR') {
                            isMPModelFound = isMPModelFound + 1;
                        }
                    }
                }
            }
        });
        var isGuestFound;
        isGuestFound = selectedReeferData.filter(row => row.DeviceConfig == true);


        if (isCT4Found > 0) {
            var eligibleForShow = ['DeviceResetToDefaults', 'Ping', 'DeviceReset', 'O2', 'StartDefrost', 'ChgDefrostInterval', 'RebootReeferController', 'ChangeReeferID', 'GetAssetId', 'EnableDoorSensor'];
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['SynctoDevice', 'ClockSyncSettings', 'ControlledAtmosphere', 'SetDataLogInterval', 'Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest'
                , 'StopPre-Trip', 'Update', 'Verify', 'MultipleSetpoints', 'AutomaticColdTreatment', 'ChangeZigbeeConfigSettings',
                'AssetConfiguration', 'Get-FreshAirType', 'Set-FreshAirType', 'ChilledandCA'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }
            var eligibleTWReportForShowHide = ['GetTripWISEReport', 'ShowTripWISEReport'];
            if (eligibleTWReportForShowHide.indexOf(cmdStr) !== -1) {
                if (tripWISEReport == true)
                    hide = false;
                else
                    hide = true;
            }
        }
        if (isDeviceTypeFound > 0) {
            var eligibleForShow = ['Ping', 'DeviceReset', 'O2', 'StartDefrost', 'ChgDefrostInterval', 'RebootReeferController', 'ChangeReeferID'];//, 'GetAssetId'
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['SetReportingInterval', 'DeviceResetToDefaults', 'SynctoDevice', 'ClockSyncSettings', 'ControlledAtmosphere', 'GetDataLog', 'SetDataLogInterval', 'Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest'
                , 'StopPre-Trip', 'ScheduledPre-Trip', 'GetPre-TripResults', 'ShowPre-TripResults', 'Update', 'Verify', 'MultipleSetpoints', 'AutomaticColdTreatment', 'ChangeZigbeeConfigSettings', 'DeviceConfiguration',
                'AssetConfiguration', 'Get-FreshAirType', 'Set-FreshAirType', 'ChilledandCA', 'GetAssetId', 'GetTripWISEReport', 'ShowTripWISEReport', 'EnableDoorSensor'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }
        }
        if (isLynxFound > 0) {
            var eligibleForShow = ['O2', 'CO2', 'Humidity', 'StartDefrost', 'Temperature', 'ChgDefrostInterval',
                'RebootReeferController', 'ChangeReeferID', 'GetDataLog'];
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['DeviceResetToDefaults', 'Ping', 'DeviceReset', 'SynctoDevice', 'ClockSyncSettings', 'ControlledAtmosphere',
                'SetDataLogInterval', 'Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'StopPre-Trip', 'Update',
                'Verify', 'MultipleSetpoints', 'AutomaticColdTreatment', 'ChangeZigbeeConfigSettings',
                'AssetConfiguration', 'DeviceConfiguration', 'Get-FreshAirType', 'Set-FreshAirType', 'FreshAirType', 'ChilledandCA', 'GetAssetId',
                'EnableDoorSensor', 'GuestReeferconfiguration', 'AssignPANId', 'ScheduledPre-Trip', 'GetPre-TripResults', 'ShowPre-TripResults'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }
            var eligibleTWReportForShowHide = ['GetTripWISEReport', 'ShowTripWISEReport'];
            if (eligibleTWReportForShowHide.indexOf(cmdStr) !== -1) {
                if (tripWISEReport == true)
                    hide = false;
                else
                    hide = true;
            }
        }
        if (isCT35ML5Found > 0) {
            var eligibleForShow = ['Humidity', 'StartDefrost', 'ChgDefrostInterval', 'GetDataLog'];//, 'GetAssetId'
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['Ping', 'AssignPANId', 'DeviceReset', 'RebootReeferController', 'ChangeReeferID', 'O2', 'CO2', 'SetReportingInterval', 'DeviceResetToDefaults', 'SynctoDevice', 'ClockSyncSettings', 'ControlledAtmosphere', 'SetDataLogInterval', 'Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest'
                , 'StopPre-Trip', 'ScheduledPre-Trip', 'GetPre-TripResults', 'ShowPre-TripResults', 'Update', 'Verify', 'MultipleSetpoints', 'AutomaticColdTreatment', 'ChangeZigbeeConfigSettings', 'DeviceConfiguration',
                'AssetConfiguration', 'Get-FreshAirType', 'Set-FreshAirType', 'ChilledandCA', 'GetAssetId', 'GetTripWISEReport', 'ShowTripWISEReport', 'EnableDoorSensor'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }
            if (cmdStr === 'GetDataLog') {
                if (!ShowTDDForCT35ML5)
                    hide = true;
            }
        }
        if (isCT36ML5Found > 0) {
            var eligibleForShow = ['Humidity', 'StartDefrost', 'ChgDefrostInterval', 'GetDataLog'];//, 'GetAssetId'
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['Ping', 'AssignPANId', 'DeviceReset', 'RebootReeferController', 'ChangeReeferID', 'O2', 'CO2', 'SetReportingInterval', 'DeviceResetToDefaults', 'SynctoDevice', 'ClockSyncSettings', 'ControlledAtmosphere', 'SetDataLogInterval', 'Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest'
                , 'StopPre-Trip', 'ScheduledPre-Trip', 'GetPre-TripResults', 'ShowPre-TripResults', 'Update', 'Verify', 'MultipleSetpoints', 'AutomaticColdTreatment', 'ChangeZigbeeConfigSettings', 'DeviceConfiguration',
                'AssetConfiguration', 'Get-FreshAirType', 'Set-FreshAirType', 'ChilledandCA', 'GetAssetId', 'GetTripWISEReport', 'ShowTripWISEReport', 'EnableDoorSensor'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }

            if (cmdStr === 'GetDataLog') {
                if (!ShowTDDForCT36ML5)
                    hide = true;
            }
        }
        if (isSekstantFound > 0 && selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S')) {
            var eligibleForShow = ['O2', 'CO2', 'Humidity', 'GetDataLog'];
            if (eligibleForShow.indexOf(cmdStr) !== -1)
                hide = false;
            else
                hide = true;
        }

        var customerTypeCd = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerTypeCd;
        var eligibleForHide = ['DeviceConfiguration', 'EnableDoorSensor']; // WI 26604 added 'EnableDoorSensor' access only for SO User
        if (eligibleForHide.indexOf(cmdStr) !== -1 && customerTypeCd != "SO") {
            hide = true;
        }
        if (selectedReeferData.length > 1) {
            if (selectedReeferData.length == selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C').length) {
                if (isGuestFound.length == selectedReeferData.length) {
                    if (cmdStr === 'Humidity') {
                        hide = true;
                    }
                }
            }
            if (selectedReeferData.length == selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length) {
                var eligibleForHide = ['O2', 'CO2', 'CAFull', 'CAFunctionTest'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            else if (selectedReeferData.length == selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length) {
                if (isSekstantFound > 0) {
                    var eligibleForHide = ['Chilled', 'Frozen', 'CA', 'ChilledandCA'];
                    if (eligibleForHide.indexOf(cmdStr) !== -1) {
                        hide = true;
                    }
                }
                else {
                    var eligibleForHide = ['Chilled', 'O2', 'CO2', 'Frozen', 'CA', 'ChilledandCA'];
                    if (eligibleForHide.indexOf(cmdStr) !== -1) {
                        hide = true;
                    }
                }
            }
            else if ((selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length > 0) && (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length > 0) && selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length)) {
                if (isSekstantFound > 0) {
                    var eligibleForShow = ['Humidity', 'GetDataLog'];
                    if (eligibleForShow.indexOf(cmdStr) !== -1) {
                        hide = false;
                    }
                    var eligibleForHide = ['Chilled', 'O2', 'CO2'];
                    if (eligibleForHide.indexOf(cmdStr) !== -1) {
                        hide = true;
                    }
                }
                else {
                    var eligibleForHide = ['Chilled', 'O2', 'CO2'];
                    if (eligibleForHide.indexOf(cmdStr) !== -1) {
                        hide = true;
                    }
                }
            }
            else {
                var eligibleForHide = ['ControlledAtmosphere'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }

            }

            if (selectedReeferData.length == selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length) {
                var eligibleForShow = ['CAFull', 'CAFunctionTest'];
                if (eligibleForShow.indexOf(cmdStr) !== -1) {
                    hide = false;
                }
            }
            if (selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C' && row.DeviceConfig == true).length)) {

                if (isSekstantFound > 0 && (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length == isSekstantFound && selectedReeferData.length == selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length)) {
                    var eligibleForShow = ['O2', 'CO2'];
                    if (eligibleForShow.indexOf(cmdStr) !== -1) {
                        hide = false;
                    }
                }
                else {
                    var eligibleForHide = ['O2', 'CO2'];
                    if (eligibleForHide.indexOf(cmdStr) !== -1) {
                        hide = true;
                    }
                }
            }
            if (selectedReeferData.length == selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C' && row.ReeferOEMTypeCd && row.DeviceConfig == true).length) {
                var eligibleForHide = ['SetDataLogInterval'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length > 0) {
                var eligibleForHide = ['ChgDefrostInterval'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C').length)) {
                var eligibleForHide = ['Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'ChilledandCA'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if ((selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C').length > 0) && (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length > 0) && selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length)) {
                var eligibleForHide = ['Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'ChilledandCA'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if ((selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length > 0) && (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length > 0) && selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length)) {
                var eligibleForHide = ['Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'ChilledandCA'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            else if ((selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length > 0) && (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'T').length > 0) && selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'T').length)) {
                var eligibleForHide = ['Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'ChilledandCA'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            else if ((selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C').length > 0) && (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'T').length > 0) && selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'T').length)) {
                var eligibleForHide = ['Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'ChilledandCA'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            else if ((selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length > 0) && (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'T').length > 0) && selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'S').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'T').length)) {
                var eligibleForHide = ['Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'ChilledandCA'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            else if ((selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length > 0) && (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C').length > 0) && selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'D').length + selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() == 'C').length)) {
                var eligibleForHide = ['Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'ChilledandCA'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (selectedReeferData.length != (isCT4Found) || isFromVessel > 0) {//isDeviceTypeFound +
                var eligibleForHide = ['GetAssetId']
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (selectedReeferData.length != isCT4Found) {
                var eligibleForHide = ['GetTripWISEReport', 'ShowTripWISEReport', 'EnableDoorSensor']
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }

            if (selectedReeferData.length != isLynxFound) {
                var eligibleForHide = ['GetTripWISEReport', 'ShowTripWISEReport']
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (selectedReeferData.length == isLynxFound) {
                var eligibleForShow = ['GetTripWISEReport', 'ShowTripWISEReport']
                if (eligibleForShow.indexOf(cmdStr) !== -1) {
                    hide = false;
                }
            }
        }
        else {
            var ReeferOEMTypeCd = "";
            if (selectedReeferData[0].ReeferOEMTypeCd != null)
                ReeferOEMTypeCd = selectedReeferData[0].ReeferOEMTypeCd;
            var IsGuest = selectedReeferData[0].DeviceConfig;
            if (ReeferOEMTypeCd.trim() == 'D') {
                var eligibleForHide = ['O2', 'CO2', 'CAFull', 'CAFunctionTest'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            else if (ReeferOEMTypeCd.trim() == 'S') {
                if (isSekstantFound > 0) {
                    var eligibleForHide = ['Chilled', 'ChgDefrostInterval', 'Frozen', 'CA', 'ChilledandCA'];
                    if (eligibleForHide.indexOf(cmdStr) !== -1) {
                        hide = true;
                    }
                }
                else {
                    var eligibleForHide = ['O2', 'CO2', 'Chilled', 'ChgDefrostInterval', 'Frozen', 'CA', 'ChilledandCA'];
                    if (eligibleForHide.indexOf(cmdStr) !== -1) {
                        hide = true;
                    }
                }
            }
            if ((ReeferOEMTypeCd.trim() == 'C' && IsGuest) || (ReeferOEMTypeCd.trim() == 'S') || (ReeferOEMTypeCd.trim() == 'D')) {

                if (!(isSekstantFound > 0 && ReeferOEMTypeCd.trim() == 'S')) {
                    var eligibleForHide = ['O2', 'CO2'];
                    if (eligibleForHide.indexOf(cmdStr) !== -1) {
                        hide = true;
                    }
                }
            }
            if (ReeferOEMTypeCd.trim() == 'C' && IsGuest) {
                var eligibleForHide = ['SetDataLogInterval'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (ReeferOEMTypeCd.trim() == 'C' || ReeferOEMTypeCd.trim() == 'T') {
                var eligibleForHide = ['ControlledAtmosphere', 'CAFull', 'CAFunctionTest', 'Frozen', 'CA', 'ChilledandCA', 'Chilled'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (!(isCT4Found > 0)) {//isDeviceTypeFound > 0 ||
                var eligibleForHide = ['GetAssetId']
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (isFromVessel > 0) {
                var eligibleForHide = ['GetAssetId']
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (!(isCT4Found > 0)) {
                var eligibleForHide = ['GetTripWISEReport', 'ShowTripWISEReport', 'EnableDoorSensor']
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (!(isLynxFound > 0)) {
                var eligibleForHide = ['GetTripWISEReport', 'ShowTripWISEReport']
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (isLynxFound > 0) {
                var eligibleForShow = ['GetTripWISEReport', 'ShowTripWISEReport']
                if (eligibleForShow.indexOf(cmdStr) !== -1) {
                    hide = false;
                }
            }
        }

        //RCNG - 3641
        //if (cmdStr === 'ShowTripWISEReport' || cmdStr === 'GetTripWISEReport') {
        //    if (tripWISEReport == true) {
        //        var supportedDeviceTypes = ["CT4000", "TripLink"];
        //        if (selectedReeferData.length > 1) {
        //            var result = selectedReeferData.filter(x => x.DeviceType.trim() == "CT4000" || x.DeviceType.trim() == "TripLink");
        //            if (selectedReeferData.length != result.length)
        //                hide = true;
        //            else
        //                hide = false;
        //        }
        //        else {
        //            if (selectedReeferData[0].DeviceType.trim() == "CT4000" || selectedReeferData[0].DeviceType.trim() == 'TripLink')
        //                hide = false;
        //            else
        //                hide = true;
        //        }
        //    }
        //}

        if (isMPModelFound > 0) {
            var eligibleForHide = ['SynctoDevice', 'SetDataLogInterval'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }
            //else { // Commented else code for WI 26604 
            //    hide = false; 
            //}
        }

        var userRights: any = sessionStorage.getItem('userRights');
        var rights = JSON.parse(userRights);
        if (rights != null && rights != undefined) {
            var rightValue = [parseInt(rightId)];
            var isValueExits = $.inArray(rightValue.toString(), rights);
            if (isValueExits == -1) {
                visibilitySetting.push('hidden');
            }
            if (isValueExits != -1 && hide) {
                visibilitySetting.push('hidden');
            }
        }
        return visibilitySetting;
    },
    //RCNG-3145
    checkTripWISEVisibilitybyData:(rightId: string, params, cmdStr, tripWiseSupport:any) => {
        var tripWISEReport;
        tripWISEReport = JSON.parse(sessionStorage.getItem('customerDetails')).TripWISEreport;
        var visibilitySetting = [];
        var hide = true;
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });

        //RCNG - 3641
        if (cmdStr === 'ShowTripWISEReport' || cmdStr === 'GetTripWISEReport') {
            if (tripWISEReport == true) {
                if (selectedReeferData.filter(x => x.DeviceType === undefined || x.DeviceType === null).length == 0) {
                if (selectedReeferData.length > 1) {
                    var result = selectedReeferData.filter(x => tripWiseSupport.includes(x.DeviceType.toUpperCase()));
                    if (selectedReeferData.length != result.length)
                        hide = true;
                    else
                        hide = false;
                }
                else {
                    if (tripWiseSupport.includes(selectedReeferData[0].DeviceType.toUpperCase()))
                        hide = false;
                    else
                        hide = true;
                    }
                }
            }
        }

        //if (isMPModelFound > 0) {
        //    var eligibleForHide = ['SynctoDevice', 'SetDataLogInterval'];
        //    if (eligibleForHide.indexOf(cmdStr) !== -1) {
        //        hide = true;
        //    }
        //    //else { // Commented else code for WI 26604 
        //    //    hide = false; 
        //    //}
        //}

        var userRights: any = sessionStorage.getItem('userRights');
        var rights = JSON.parse(userRights);
        if (rights != null && rights != undefined) {
            var rightValue = [parseInt(rightId)];
            var isValueExits = $.inArray(rightValue.toString(), rights);
            if (isValueExits == -1) {
                visibilitySetting.push('hidden');
            }
            if (isValueExits != -1 && hide) {
                visibilitySetting.push('hidden');
            }
        }
        return visibilitySetting;
    },
    //getCCAlarmStatus(selectedReeferData) {
    //    var isDisabled = false;
    //    var forwardCommandParams = JSON.stringify(selectedReeferData);
    //    var url = Config.ApiBaseUrl + '/api/ReeferStatus/GetCCAlarmStatus';
    //    var request = RCUtils.FetchRequest(url, { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
    //    fetch(request)
    //        .then(RCUtils.handleError)
    //        .then(response => response.json() as Promise<boolean>)
    //        .then(data => {
    //            if (data) {
    //                return isDisabled = false;
    //            }
    //            else {
    //                return isDisabled = true;
    //            }
    //        });
    //},
    //async checkMenuItemClearSetPointDisabled(params) {
    //    // var isClearSetPointDisabled = true;
    //    var selectedReeferData = [];
    //    var selectedRows = params.api.getSelectedRows();
    //    selectedRows.forEach(function (selectedRow, index) {
    //        selectedReeferData.push(selectedRow);
    //    });
    //    var result = await this.getCCAlarmStatus(selectedReeferData);
    //    return result;
    //    //var forwardCommandParams = JSON.stringify(selectedReeferData);
    //    //var url = Config.ApiBaseUrl + '/api/ReeferStatus/GetCCAlarmStatus';
    //    //var request = RCUtils.FetchRequest(url, { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
    //    //fetch(request)
    //    //    .then(RCUtils.handleError)
    //    //    .then(response => response.json() as Promise<boolean>)
    //    //    .then(data => {
    //    //        if (data) {
    //    //            isClearSetPointDisabled = false;
    //    //        }
    //    //        else {
    //    //            isClearSetPointDisabled = true;
    //    //        }
    //    //    });
    //    // return isClearSetPointDisabled;
    //},
    checkCCAssignSubMenuItemDisabled(params, ccProfileId, cmdStr) {
        var Isdisabled = false;
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });

        if (selectedReeferData.length > 1) {
            return Isdisabled;
        }
        else {
            if (cmdStr === "AssigntoCargoCare") {
                var checkProfileId = selectedReeferData[0].CargoCareCustomerProfileID;
                if (checkProfileId == ccProfileId)
                    Isdisabled = true;

                return Isdisabled;
            }
        }

        return Isdisabled;
    },

    checkClearCargoCareAlertsSubMenuItemDisabled(params, cmdStr) {
        var Isdisabled = false;
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });

        if (selectedReeferData.length > 1) {
            return Isdisabled;
        }
        else {
            if (cmdStr === "ClearCargoCareAlerts") {
                Isdisabled = true;
                if (selectedReeferData[0].CCAlarms != null && selectedReeferData[0].CCAlarms != "") {
                    if (selectedReeferData[0].IsCargoCare)
                        Isdisabled = false;
                    else
                        Isdisabled = true;
                }

                return Isdisabled;
            }
        }

        return Isdisabled;
    },
    checkMenuItemDisabledForDefrost(params, cmdStr, refControllertypes: any) {
        var Isdisabled = false;
        var selectedReeferData = [];
        var isGuestFound;
        isGuestFound = selectedReeferData.filter(row => row.DeviceConfig == true);
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });
        var isDeviceTypeFound = 0;
        var isCT4Found = 0;
        var isLynxDeviceFound = 0;
        var isCT35ML5Found = 0;
        var isCT36ML5Found = 0;
        $.each(selectedReeferData, function (i, val) {
            if (val.DeviceType != null && val.DeviceType != undefined) {
                if (val.DeviceType.toString().trim() == 'CT5000') {
                    isDeviceTypeFound = isDeviceTypeFound + 1;
                }
                if (val.DeviceType.toString().trim() == 'CT4000') {
                    isCT4Found = isCT4Found + 1;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'TRIPLINK') {
                    isLynxDeviceFound = isLynxDeviceFound + 1;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'CT3500' || val.DeviceType.toString().trim().toUpperCase() == 'CT3600') { //IOT Token ML5 on CT 35/36
                    var controllerDesc = "";
                    var controllertype = lodashfilter(refControllertypes, function (item) {
                        return item.ControllerTypeCd === val.ControllerTypeCd;
                    });
                    if (controllertype.length > 0 && controllertype != null) {
                        controllerDesc = controllertype[0].ControllerDesc;
                    }
                    if (controllerDesc == 'ML5')
                        isCT35ML5Found = isCT35ML5Found + 1;
                }
                //if (val.DeviceType.toString().trim().toUpperCase() == 'CT3600') { //IOT Token ML5 on CT 35/36
                //    var controllerDesc = "";
                //    var controllertype = lodashfilter(refControllertypes, function (item) {
                //        return item.ControllerTypeCd === val.ControllerTypeCd;
                //    });
                //    if (controllertype.length > 0 && controllertype != null) {
                //        controllerDesc = controllertype[0].ControllerDesc;
                //    }
                //    if (controllerDesc == 'ML5')
                //        isCT36ML5Found = isCT36ML5Found + 1;
                //}
            }
        });
        //RCNG-41 start
        if (cmdStr === "RetireOrReactivate") {
            var isActiveFound = 0;
            var isDisconnectedFound = 0;
            var isRetiredFound = 0;
            $.each(selectedReeferData, function (i, val) {
                if (val.AssetState != null && val.AssetState != undefined) {
                    if (val.AssetState.toString().trim() == 'A') {
                        isActiveFound = isActiveFound + 1;
                    }
                    if (val.AssetState.toString().trim() == 'D') {
                        isDisconnectedFound = isDisconnectedFound + 1;
                    }
                    if (val.AssetState.toString().trim() == 'R') {
                        isRetiredFound = isRetiredFound + 1;
                    }
                }
            });

            if ((isActiveFound > 0 || isDisconnectedFound > 0) && isRetiredFound > 0) {
                Isdisabled = true;
            }
        }
        //RCNG-41 end
        //RCNG-820
        //if (cmdStr === "EditVoyage") {
        //    if (selectedReeferData != null && selectedReeferData != undefined && selectedReeferData.length > 1) {
        //        var depVVCs = [];
        //        var arrVVCs = [];
        //        var arrVessel = [];
        //        var arrLifeCycleCD = [];
        //        $.each(selectedReeferData, function (i, val) {
        //            if (val.DepartingVVC != null && val.DepartingVVC != undefined) {
        //                depVVCs.push(val.DepartingVVC.toString().trim());
        //            }
        //            if (val.ArrivingVVC != null && val.ArrivingVVC != undefined) {
        //                arrVVCs.push(val.ArrivingVVC.toString().trim());
        //            }
        //            if (val.VesselCd != null && val.VesselCd != undefined) {
        //                arrVessel.push(val.VesselCd.toString().trim());
        //            }
        //            if (val.LifecycleCd != null && val.LifecycleCd != undefined) {
        //                arrLifeCycleCD.push(val.LifecycleCd.toString().trim());
        //            }
        //        });
        //        const allEqual = arr => arr.every(v => v === arr[0])
        //        if (!allEqual(depVVCs) || !allEqual(arrVVCs) || !allEqual(arrVessel) || !allEqual(arrLifeCycleCD)) {
        //            Isdisabled = true;
        //        }
        //    }
        //}
        if (cmdStr === "ClearSetPoint") {
            Isdisabled = true;
            if (selectedReeferData[0].IsSetPoint != null) {

                if (selectedReeferData[0].IsSetPoint === 1)
                    Isdisabled = false;
                else if (selectedReeferData[0].IsSetPoint === 0)
                    Isdisabled = true;
            }

            return Isdisabled;
            //var forwardCommandParams = JSON.stringify(selectedReeferData);
            //var url = Config.ApiBaseUrl + '/api/ReeferStatus/GetCCAlarmStatus';
            //var request = RCUtils.FetchRequest(url, { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            //fetch(request)
            //    .then(RCUtils.handleError)
            //    .then(response => response.json() as Promise<boolean>)
            //    .then(data => {
            //        if (data) {
            //                Isdisabled = false;
            //        }
            //        else {
            //                Isdisabled = true;
            //        }
            //    });
        }

        if (cmdStr === "CurrentDetails") {
            Isdisabled = false;
            if (selectedReeferData[0].ReeferID == null || selectedReeferData[0].ReeferID == undefined || selectedReeferData[0].ReeferID == '')
                Isdisabled = true;
        }

        if (selectedReeferData.length > 1) {
            var isAssignCargo = selectedReeferData[0].IsCargoCare;
            if (cmdStr === "CurrentDetails" || cmdStr === "ShowPreTripResults" || cmdStr === "ConfirmControllerSwap" || cmdStr === "BookingandAccess" || cmdStr === "ChangeReeferID" || cmdStr === "ShowTripWISEReport" || cmdStr === "NewBookingandAccess") {
                Isdisabled = true;
            }

            if (isGuestFound.length > 0) {
                if (cmdStr === "SetReportingInterval")
                    Isdisabled = true;

            }
            if (selectedReeferData[0].TripStatusCd != null) {
                if (dflag) {
                    if (cmdStr === "ClearDeviation")
                        Isdisabled = false;
                } else {
                    if (cmdStr === "ClearDeviation")
                        Isdisabled = true;
                }
            }
            else {
                if (cmdStr === "ClearDeviation")
                    Isdisabled = true;
            }
            if (isAssignCargo) {
                if (cmdStr === "UnassignfromCargoCare")
                    Isdisabled = false;
                if (cmdStr === "AssigntoCargoCare")
                    Isdisabled = true;
            }
            else {
                if (cmdStr === "UnassignfromCargoCare")
                    Isdisabled = true;
                if (cmdStr === "AssigntoCargoCare")
                    Isdisabled = false;
            }
            if (cmdStr === 'Humidity') {
                if ((isCT4Found > 0 || isDeviceTypeFound > 0 || isLynxDeviceFound > 0) && (isDeviceTypeFound + isCT4Found + isLynxDeviceFound) != selectedReeferData.length) {
                    Isdisabled = true;
                }
            }
            if (cmdStr === 'ChgDefrostInterval') {
                if ((isCT35ML5Found > 0) && (isCT35ML5Found) != selectedReeferData.length) {
                    Isdisabled = true;
                }
            }
            if (isLynxDeviceFound > 0) {
                var eligibleForShow = ['O2', 'CO2', 'StartDefrost', 'Temperature', 'ChgDefrostInterval', 'RebootReeferController',
                    'Defrost', 'GetTripWISEReport'];
                if (eligibleForShow.indexOf(cmdStr) !== -1) {
                    Isdisabled = false;
                }
                var eligibleForHide = ['DeviceResetToDefaults', 'Ping', 'DeviceReset', 'SynctoDevice', 'ClockSyncSettings', 'ControlledAtmosphere',
                    'SetDataLogInterval', 'Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'StopPre-Trip', 'Update',
                    'Verify', 'MultipleSetpoints', 'AutomaticColdTreatment', 'ChangeZigbeeConfigSettings',
                    'AssetConfiguration', 'DeviceConfiguration', 'Get-FreshAirType', 'Set-FreshAirType', 'FreshAirType', 'ChilledandCA', 'GetAssetId',
                    'EnableDoorSensor', 'GuestReeferconfiguration', 'AssignPANId', 'StartPre-Trip', 'ChangeReeferID'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    Isdisabled = true;
                }
            }

        }
        else {
            var ReeferOEMTypeCd = "";
            var dflag = selectedReeferData[0].DeviationFlg;
            var csflag = selectedReeferData[0].ControllerSerialNumberChgFlag;
            var isAssignCargo = selectedReeferData[0].IsCargoCare;
            if (selectedReeferData[0].ReeferOEMTypeCd != null)
                ReeferOEMTypeCd = selectedReeferData[0].ReeferOEMTypeCd;
            if (ReeferOEMTypeCd != null && ReeferOEMTypeCd != undefined && ReeferOEMTypeCd != '') {
                if (ReeferOEMTypeCd.toString().trim() == 'U') {
                    if (cmdStr === "Defrost" || cmdStr === "StartPre-Trip" || cmdStr === "StopPre-Trip")
                        Isdisabled = true;
                }
                if (ReeferOEMTypeCd.trim() == 'TR') {
                    if (cmdStr === "Verify")
                        Isdisabled = true;
                }
                if ((ReeferOEMTypeCd.trim() == 'S') || (ReeferOEMTypeCd.trim() == 'T')) {
                    if (cmdStr === "ChgDefrostInterval")
                        Isdisabled = true;
                }
                if (ReeferOEMTypeCd.trim() == 'C' && (isGuestFound.length > 0)) {
                    if (cmdStr === "ChgDefrostInterval")
                        Isdisabled = true;
                }
                if (ReeferOEMTypeCd.trim() == 'T' || ReeferOEMTypeCd.trim() == 'U') {
                    if (cmdStr === "ShowPreTripResults") {
                        if (ReeferOEMTypeCd.trim() == 'T') {
                            if (selectedReeferData[0].OEMModel != null && selectedReeferData[0].OEMModel != undefined && selectedReeferData[0].OEMModel != '') {
                                if (selectedReeferData[0].OEMModel != 'MP3000' && selectedReeferData[0].OEMModel != 'MP3000A') {
                                    Isdisabled = true;
                                }
                            }
                            else
                                Isdisabled = true;
                        }
                        else
                            Isdisabled = true;
                    }
                }
            }
            else {
                if (cmdStr === "ShowPreTripResults")
                    Isdisabled = true;
            }
            //if (cmdStr === "Unassign") {
            //    Isdisabled = true;

            //    var validateBookingID = false;
            //    if (selectedReeferData[0].BookingNumber != null) {
            //        //var lastBookDissociatedEventMasterId = lodashfilter(self.state.reeferFormatter.EventMasterList, function (item) {
            //        //    return item.EventCd.toUpperCase().trim() === "BDR";
            //        //});

            //        //var lastBookDeletedEventMasterId = lodashfilter(self.state.reeferFormatter.EventMasterList, function (item) {
            //        //    return item.EventCd.toUpperCase().trim() === "BDD";
            //        //});

            //        //var lastBookingEventDetails = [];
            //        //if (lastBookDissociatedEventMasterId != null)
            //        //    lastBookingEventDetails.push(lastBookDissociatedEventMasterId[0].EventMasterID);
            //        //if (lastBookDeletedEventMasterId != null)
            //        //    lastBookingEventDetails.push(lastBookDeletedEventMasterId[0].EventMasterID);
            //        //if (lastBookingEventDetails.length > 0 && lastBookingEventDetails[0].LastBookingEventMasterId != null && lastBookingEventDetails[0].LastBookingEventMasterId.length > 0) {
            //        //    for (var lastBookingID in lastBookingEventDetails) {
            //        //        if (selectedReeferData[0].EventMasterID == parseInt(lastBookingEventDetails[0].LastBookingEventMasterId[lastBookingID])) {
            //        //            validateBookingID = true;
            //        //        }
            //        //    }
            //        //}
            //        //if (selectedReeferData.length > 0 && selectedReeferData[0].LastBookingEventMasterId != null && selectedReeferData[0].LastBookingEventMasterId.length > 0) {
            //        //    for (var lastBookingID in selectedReeferData[0].LastBookingEventMasterId) {
            //        //        if (selectedReeferData[0].EventMasterID == parseInt(selectedReeferData[0].LastBookingEventMasterId[lastBookingID])) {
            //        //            validateBookingID = true;
            //        //        }
            //        //    }
            //        //}
            //    }
            //    //if (selectedReeferData[0].BookingNumber != null && !self.ValidateBookingID(selectedReeferData)) {
            //    if (selectedReeferData[0].BookingNumber != null && !validateBookingID) {
            //        Isdisabled = false;
            //    }
            //    else {
            //        //var forwardCommandParam = JSON.stringify(selectedReeferData);
            //        //var url = Config.ApiBaseUrl + '/api/ReeferStatus/GetUnitAssigned3rdParty';
            //        //var request = RCUtils.FetchRequest(url, { method: 'POST', body: forwardCommandParam, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            //        //fetch(request)
            //        //    .then(RCUtils.handleError)
            //        //    .then(response => response.json() as Promise<boolean>)
            //        //    .then(data => {
            //        //        if (data) {
            //        //            if (cmdStr === "Unassign")
            //        //                 Isdisabled = false;
            //        //        }
            //        //        else {
            //        //            if (cmdStr === "Unassign")
            //        //                 Isdisabled = true;
            //        //        }
            //        //    });
            //        if (selectedReeferData != null && selectedReeferData != undefined) {
            //            if (selectedReeferData[0].CustomerName != "") {
            //                if (selectedReeferData[0].CustomerName === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName) {
            //                    Isdisabled = true;
            //                } else {
            //                    Isdisabled = false;
            //                }
            //            }
            //        }
            //    }
            //}
            if (isAssignCargo) {
                if (cmdStr === "UnassignfromCargoCare")
                    Isdisabled = false;
                if (cmdStr === "AssigntoCargoCare")
                    Isdisabled = true;
            }
            else {
                if (cmdStr === "UnassignfromCargoCare")
                    Isdisabled = true;
                if (cmdStr === "AssigntoCargoCare")
                    Isdisabled = false;
            }
            if (csflag) {
                if (cmdStr === "ConfirmControllerSwap")
                    Isdisabled = false;
            }
            if (selectedReeferData[0].TripStatusCd != null) {
                if (dflag) {
                    if (cmdStr === "ClearDeviation")
                        Isdisabled = false;
                } else {
                    if (cmdStr === "ClearDeviation")
                        Isdisabled = true;
                }
            } else {
                if (cmdStr === "ClearDeviation")
                    Isdisabled = true;
            }

            if (isLynxDeviceFound > 0) {
                var eligibleForShow = ['O2', 'CO2', 'Humidity', 'StartDefrost', 'Temperature', 'ChgDefrostInterval', 'RebootReeferController',
                    'ChangeReeferID', 'Defrost', 'GetTripWISEReport', 'ShowTripWISEReport', 'StartPre-Trip'];
                if (eligibleForShow.indexOf(cmdStr) !== -1) {
                    Isdisabled = false;
                }
                var eligibleForHide = ['DeviceResetToDefaults', 'Ping', 'DeviceReset', 'SynctoDevice', 'ClockSyncSettings', 'ControlledAtmosphere',
                    'SetDataLogInterval', 'Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'StopPre-Trip', 'Update',
                    'Verify', 'MultipleSetpoints', 'AutomaticColdTreatment', 'ChangeZigbeeConfigSettings',
                    'AssetConfiguration', 'DeviceConfiguration', 'Get-FreshAirType', 'Set-FreshAirType', 'FreshAirType', 'ChilledandCA', 'GetAssetId',
                    'EnableDoorSensor', 'GuestReeferconfiguration', 'AssignPANId'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    Isdisabled = true;
                }
            }

        }
        return Isdisabled;
    },
    checkMenuItemDisabledForTDD(params, cmdStr, refControllertypes: any) {
        var Isdisabled = false;
        var selectedReeferData = [];
        var isGuestFound;
        isGuestFound = selectedReeferData.filter(row => row.DeviceConfig == true);
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });
        var isCT35ML5Found = 0;
        var isCT36ML5Found = 0;
        $.each(selectedReeferData, function (i, val) {
            if (val.DeviceType != null && val.DeviceType != undefined) {
                if (val.DeviceType.toString().trim().toUpperCase() == 'CT3500') { //IOT Token ML5 on CT 35/36
                    var controllerDesc = "";
                    var controllertype = lodashfilter(refControllertypes, function (item) {
                        return item.ControllerTypeCd === val.ControllerTypeCd;
                    });
                    if (controllertype.length > 0 && controllertype != null) {
                        controllerDesc = controllertype[0].ControllerDesc;
                    }
                    if (controllerDesc == 'ML5')
                        isCT35ML5Found = isCT35ML5Found + 1;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'CT3600') { //IOT Token ML5 on CT 35/36
                    var controllerDesc = "";
                    var controllertype = lodashfilter(refControllertypes, function (item) {
                        return item.ControllerTypeCd === val.ControllerTypeCd;
                    });
                    if (controllertype.length > 0 && controllertype != null) {
                        controllerDesc = controllertype[0].ControllerDesc;
                    }
                    if (controllerDesc == 'ML5')
                        isCT36ML5Found = isCT36ML5Found + 1;
                }
            }
        });
        if (selectedReeferData.length > 1) {
            if (cmdStr === 'ReeferDataLog') {
                if ((isCT36ML5Found > 0 || isCT35ML5Found > 0) && (isCT36ML5Found + isCT35ML5Found) != selectedReeferData.length) {
                    Isdisabled = true;
                }
            }
        }
        return Isdisabled;
    },
    checkMenuItemDisabled(params, cmdStr) {
        var Isdisabled = false;
        var selectedReeferData = [];
        var isGuestFound;
        isGuestFound = selectedReeferData.filter(row => row.DeviceConfig == true);
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });
        var isDeviceTypeFound = 0;
        var isCT4Found = 0;
        var isLynxDeviceFound = 0;
        $.each(selectedReeferData, function (i, val) {
            if (val.DeviceType != null && val.DeviceType != undefined) {
                if (val.DeviceType.toString().trim() == 'CT5000') {
                    isDeviceTypeFound = isDeviceTypeFound + 1;
                }
                if (val.DeviceType.toString().trim() == 'CT4000') {
                    isCT4Found = isCT4Found + 1;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'TRIPLINK') {
                    isLynxDeviceFound = isLynxDeviceFound + 1;
                }
            }
        });
        //RCNG-41 start
        if (cmdStr === "RetireOrReactivate") {
            var isActiveFound = 0;
            var isDisconnectedFound = 0;
            var isRetiredFound = 0;
            $.each(selectedReeferData, function (i, val) {
                if (val.AssetState != null && val.AssetState != undefined) {
                    if (val.AssetState.toString().trim() == 'A') {
                        isActiveFound = isActiveFound + 1;
                    }
                    if (val.AssetState.toString().trim() == 'D') {
                        isDisconnectedFound = isDisconnectedFound + 1;
                    }
                    if (val.AssetState.toString().trim() == 'R') {
                        isRetiredFound = isRetiredFound + 1;
                    }
                }
            });

            if ((isActiveFound > 0 || isDisconnectedFound > 0) && isRetiredFound > 0) {
                Isdisabled = true;
            }
        }
        //RCNG-41 end
        //RCNG-820
        //if (cmdStr === "EditVoyage") {
        //    if (selectedReeferData != null && selectedReeferData != undefined && selectedReeferData.length > 1) {
        //        var depVVCs = [];
        //        var arrVVCs = [];
        //        var arrVessel = [];
        //        var arrLifeCycleCD = [];
        //        $.each(selectedReeferData, function (i, val) {
        //            if (val.DepartingVVC != null && val.DepartingVVC != undefined) {
        //                depVVCs.push(val.DepartingVVC.toString().trim());
        //            }
        //            if (val.ArrivingVVC != null && val.ArrivingVVC != undefined) {
        //                arrVVCs.push(val.ArrivingVVC.toString().trim());
        //            }
        //            if (val.VesselCd != null && val.VesselCd != undefined) {
        //                arrVessel.push(val.VesselCd.toString().trim());
        //            }
        //            if (val.LifecycleCd != null && val.LifecycleCd != undefined) {
        //                arrLifeCycleCD.push(val.LifecycleCd.toString().trim());
        //            }
        //        });
        //        const allEqual = arr => arr.every(v => v === arr[0])
        //        if (!allEqual(depVVCs) || !allEqual(arrVVCs) || !allEqual(arrVessel) || !allEqual(arrLifeCycleCD)) {
        //            Isdisabled = true;
        //        }
        //    }
        //}
        if (cmdStr === "ClearSetPoint") {
            Isdisabled = true;
            if (selectedReeferData[0].IsSetPoint != null) {

                if (selectedReeferData[0].IsSetPoint === 1)
                    Isdisabled = false;
                else if (selectedReeferData[0].IsSetPoint === 0)
                    Isdisabled = true;
            }

            return Isdisabled;
            //var forwardCommandParams = JSON.stringify(selectedReeferData);
            //var url = Config.ApiBaseUrl + '/api/ReeferStatus/GetCCAlarmStatus';
            //var request = RCUtils.FetchRequest(url, { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            //fetch(request)
            //    .then(RCUtils.handleError)
            //    .then(response => response.json() as Promise<boolean>)
            //    .then(data => {
            //        if (data) {
            //                Isdisabled = false;
            //        }
            //        else {
            //                Isdisabled = true;
            //        }
            //    });
        }

        if (cmdStr === "CurrentDetails") {
            Isdisabled = false;
            if (selectedReeferData[0].ReeferID == null || selectedReeferData[0].ReeferID == undefined || selectedReeferData[0].ReeferID == '')
                Isdisabled = true;
        }

        if (selectedReeferData.length > 1) {
            var isAssignCargo = selectedReeferData[0].IsCargoCare;
            if (cmdStr === "CurrentDetails" || cmdStr === "ShowPreTripResults" || cmdStr === "ConfirmControllerSwap" || cmdStr === "BookingandAccess" || cmdStr === "ChangeReeferID" || cmdStr === "ShowTripWISEReport" || cmdStr === "NewBookingandAccess") {
                Isdisabled = true;
            }

            if (isGuestFound.length > 0) {
                if (cmdStr === "SetReportingInterval")
                    Isdisabled = true;

            }
            if (selectedReeferData[0].TripStatusCd != null) {
                if (dflag) {
                    if (cmdStr === "ClearDeviation")
                        Isdisabled = false;
                } else {
                    if (cmdStr === "ClearDeviation")
                        Isdisabled = true;
                }
            }
            else {
                if (cmdStr === "ClearDeviation")
                    Isdisabled = true;
            }
            if (isAssignCargo) {
                if (cmdStr === "UnassignfromCargoCare")
                    Isdisabled = false;
                if (cmdStr === "AssigntoCargoCare")
                    Isdisabled = true;
            }
            else {
                if (cmdStr === "UnassignfromCargoCare")
                    Isdisabled = true;
                if (cmdStr === "AssigntoCargoCare")
                    Isdisabled = false;
            }
            if (cmdStr === 'Humidity') {
                if ((isCT4Found > 0 || isDeviceTypeFound > 0 || isLynxDeviceFound > 0) && (isDeviceTypeFound + isCT4Found + isLynxDeviceFound) != selectedReeferData.length) {
                    Isdisabled = true;
                }
            }
            if (isLynxDeviceFound > 0) {
                var eligibleForShow = ['O2', 'CO2', 'StartDefrost', 'Temperature', 'ChgDefrostInterval', 'RebootReeferController',
                     'Defrost', 'GetTripWISEReport'];
                if (eligibleForShow.indexOf(cmdStr) !== -1) {
                    Isdisabled = false;
                }
                var eligibleForHide = ['DeviceResetToDefaults', 'Ping', 'DeviceReset', 'SynctoDevice', 'ClockSyncSettings', 'ControlledAtmosphere',
                    'SetDataLogInterval', 'Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'StopPre-Trip', 'Update',
                    'Verify', 'MultipleSetpoints', 'AutomaticColdTreatment', 'ChangeZigbeeConfigSettings',
                    'AssetConfiguration', 'DeviceConfiguration', 'Get-FreshAirType', 'Set-FreshAirType', 'FreshAirType', 'ChilledandCA', 'GetAssetId',
                    'EnableDoorSensor', 'GuestReeferconfiguration', 'AssignPANId', 'StartPre-Trip', 'ChangeReeferID'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    Isdisabled = true;
                }
            }

        }
        else {
            var ReeferOEMTypeCd = "";
            var dflag = selectedReeferData[0].DeviationFlg;
            var csflag = selectedReeferData[0].ControllerSerialNumberChgFlag;
            var isAssignCargo = selectedReeferData[0].IsCargoCare;
            if (selectedReeferData[0].ReeferOEMTypeCd != null)
                ReeferOEMTypeCd = selectedReeferData[0].ReeferOEMTypeCd;
            if (ReeferOEMTypeCd != null && ReeferOEMTypeCd != undefined && ReeferOEMTypeCd != '') {
                if (ReeferOEMTypeCd.toString().trim() == 'U') {
                    if (cmdStr === "Defrost" || cmdStr === "StartPre-Trip" || cmdStr === "StopPre-Trip")
                        Isdisabled = true;
                }
                if (ReeferOEMTypeCd.trim() == 'TR') {
                    if (cmdStr === "Verify")
                        Isdisabled = true;
                }
                if ((ReeferOEMTypeCd.trim() == 'S') || (ReeferOEMTypeCd.trim() == 'T')) {
                    if (cmdStr === "ChgDefrostInterval")
                        Isdisabled = true;
                }
                if (ReeferOEMTypeCd.trim() == 'C' && (isGuestFound.length > 0)) {
                    if (cmdStr === "ChgDefrostInterval")
                        Isdisabled = true;
                }
                if (ReeferOEMTypeCd.trim() == 'T' || ReeferOEMTypeCd.trim() == 'U') {
                    if (cmdStr === "ShowPreTripResults") {
                        if (ReeferOEMTypeCd.trim() == 'T') {
                            if (selectedReeferData[0].OEMModel != null && selectedReeferData[0].OEMModel != undefined && selectedReeferData[0].OEMModel != '') {
                                if (selectedReeferData[0].OEMModel != 'MP3000' && selectedReeferData[0].OEMModel != 'MP3000A') {
                                    Isdisabled = true;
                                }
                            }
                            else
                                Isdisabled = true;
                        }
                        else
                            Isdisabled = true;
                    }
                }
            }
            else {
                if (cmdStr === "ShowPreTripResults")
                    Isdisabled = true;
            }
            //if (cmdStr === "Unassign") {
            //    Isdisabled = true;

            //    var validateBookingID = false;
            //    if (selectedReeferData[0].BookingNumber != null) {
            //        //var lastBookDissociatedEventMasterId = lodashfilter(self.state.reeferFormatter.EventMasterList, function (item) {
            //        //    return item.EventCd.toUpperCase().trim() === "BDR";
            //        //});

            //        //var lastBookDeletedEventMasterId = lodashfilter(self.state.reeferFormatter.EventMasterList, function (item) {
            //        //    return item.EventCd.toUpperCase().trim() === "BDD";
            //        //});

            //        //var lastBookingEventDetails = [];
            //        //if (lastBookDissociatedEventMasterId != null)
            //        //    lastBookingEventDetails.push(lastBookDissociatedEventMasterId[0].EventMasterID);
            //        //if (lastBookDeletedEventMasterId != null)
            //        //    lastBookingEventDetails.push(lastBookDeletedEventMasterId[0].EventMasterID);
            //        //if (lastBookingEventDetails.length > 0 && lastBookingEventDetails[0].LastBookingEventMasterId != null && lastBookingEventDetails[0].LastBookingEventMasterId.length > 0) {
            //        //    for (var lastBookingID in lastBookingEventDetails) {
            //        //        if (selectedReeferData[0].EventMasterID == parseInt(lastBookingEventDetails[0].LastBookingEventMasterId[lastBookingID])) {
            //        //            validateBookingID = true;
            //        //        }
            //        //    }
            //        //}
            //        //if (selectedReeferData.length > 0 && selectedReeferData[0].LastBookingEventMasterId != null && selectedReeferData[0].LastBookingEventMasterId.length > 0) {
            //        //    for (var lastBookingID in selectedReeferData[0].LastBookingEventMasterId) {
            //        //        if (selectedReeferData[0].EventMasterID == parseInt(selectedReeferData[0].LastBookingEventMasterId[lastBookingID])) {
            //        //            validateBookingID = true;
            //        //        }
            //        //    }
            //        //}
            //    }
            //    //if (selectedReeferData[0].BookingNumber != null && !self.ValidateBookingID(selectedReeferData)) {
            //    if (selectedReeferData[0].BookingNumber != null && !validateBookingID) {
            //        Isdisabled = false;
            //    }
            //    else {
            //        //var forwardCommandParam = JSON.stringify(selectedReeferData);
            //        //var url = Config.ApiBaseUrl + '/api/ReeferStatus/GetUnitAssigned3rdParty';
            //        //var request = RCUtils.FetchRequest(url, { method: 'POST', body: forwardCommandParam, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            //        //fetch(request)
            //        //    .then(RCUtils.handleError)
            //        //    .then(response => response.json() as Promise<boolean>)
            //        //    .then(data => {
            //        //        if (data) {
            //        //            if (cmdStr === "Unassign")
            //        //                 Isdisabled = false;
            //        //        }
            //        //        else {
            //        //            if (cmdStr === "Unassign")
            //        //                 Isdisabled = true;
            //        //        }
            //        //    });
            //        if (selectedReeferData != null && selectedReeferData != undefined) {
            //            if (selectedReeferData[0].CustomerName != "") {
            //                if (selectedReeferData[0].CustomerName === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName) {
            //                    Isdisabled = true;
            //                } else {
            //                    Isdisabled = false;
            //                }
            //            }
            //        }
            //    }
            //}
            if (isAssignCargo) {
                if (cmdStr === "UnassignfromCargoCare")
                    Isdisabled = false;
                if (cmdStr === "AssigntoCargoCare")
                    Isdisabled = true;
            }
            else {
                if (cmdStr === "UnassignfromCargoCare")
                    Isdisabled = true;
                if (cmdStr === "AssigntoCargoCare")
                    Isdisabled = false;
            }
            if (csflag) {
                if (cmdStr === "ConfirmControllerSwap")
                    Isdisabled = false;
            }
            if (selectedReeferData[0].TripStatusCd != null) {
                if (dflag) {
                    if (cmdStr === "ClearDeviation")
                        Isdisabled = false;
                } else {
                    if (cmdStr === "ClearDeviation")
                        Isdisabled = true;
                }
            } else {
                if (cmdStr === "ClearDeviation")
                    Isdisabled = true;
            }

            if (isLynxDeviceFound > 0) {
                var eligibleForShow = ['O2', 'CO2', 'Humidity', 'StartDefrost', 'Temperature', 'ChgDefrostInterval', 'RebootReeferController',
                    'ChangeReeferID', 'Defrost', 'GetTripWISEReport', 'ShowTripWISEReport', 'StartPre-Trip'];
                if (eligibleForShow.indexOf(cmdStr) !== -1) {
                    Isdisabled = false;
                }
                var eligibleForHide = ['DeviceResetToDefaults', 'Ping', 'DeviceReset', 'SynctoDevice', 'ClockSyncSettings', 'ControlledAtmosphere',
                    'SetDataLogInterval', 'Chilled', 'Frozen', 'CA', 'CAFull', 'CAFunctionTest', 'StopPre-Trip', 'Update',
                    'Verify', 'MultipleSetpoints', 'AutomaticColdTreatment', 'ChangeZigbeeConfigSettings',
                    'AssetConfiguration', 'DeviceConfiguration', 'Get-FreshAirType', 'Set-FreshAirType', 'FreshAirType', 'ChilledandCA', 'GetAssetId',
                    'EnableDoorSensor', 'GuestReeferconfiguration', 'AssignPANId'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    Isdisabled = true;
                }
            }

        }
        return Isdisabled;
    },
    checkMenuItemDisabledforDimiSetting(params, cmdStr) {
        var Isdisabled = false;
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });

        var isZestiaModelFound = 0;
        $.each(selectedReeferData, function (i, val) {
                if (val.ReeferOEMTypeCd != null && val.ReeferOEMTypeCd != undefined) {
                    if (val.ReeferOEMTypeCd.trim().toUpperCase() == 'D') {
                        if (val.UnitTypeCd != null && val.UnitTypeCd != undefined && val.UnitTypeCd != '') {
                            if (val.UnitTypeCd.trim().toUpperCase() == 'DV' || val.UnitTypeCd.trim().toUpperCase() == 'DA' || val.UnitTypeCd.trim().toUpperCase() == 'DB') {
                                isZestiaModelFound = isZestiaModelFound + 1;
                            }
                        }
                    }
                }
            
        });


        if (isZestiaModelFound == 0 || isZestiaModelFound != selectedReeferData.length) {
            var eligibleForHide = ['OEMPTI','FanSpeed'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                Isdisabled = true;
            }
        }
        return Isdisabled;
    },
    checkMenuItemUnAssignDisabled(params, cmdStr, EventMasterList) {
        var Isdisabled = false;
        var selectedReeferData = [];
        var isGuestFound;
        isGuestFound = selectedReeferData.filter(row => row.DeviceConfig == true);
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });
        var isDeviceTypeFound = 0;
        var isCT4Found = 0;
        $.each(selectedReeferData, function (i, val) {
            if (val.DeviceType != null && val.DeviceType != undefined) {
                if (val.DeviceType.toString().trim() == 'CT5000') {
                    isDeviceTypeFound = isDeviceTypeFound + 1;
                }
                if (val.DeviceType.toString().trim() == 'CT4000') {
                    isCT4Found = isCT4Found + 1;
                }
            }
        });
        if (cmdStr === "ClearSetPoint") {
            Isdisabled = true;
            if (selectedReeferData[0].IsSetPoint != null) {

                if (selectedReeferData[0].IsSetPoint === 1)
                    Isdisabled = false;
                else if (selectedReeferData[0].IsSetPoint === 0)
                    Isdisabled = true;
            }

            return Isdisabled;
            //var forwardCommandParams = JSON.stringify(selectedReeferData);
            //var url = Config.ApiBaseUrl + '/api/ReeferStatus/GetCCAlarmStatus';
            //var request = RCUtils.FetchRequest(url, { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            //fetch(request)
            //    .then(RCUtils.handleError)
            //    .then(response => response.json() as Promise<boolean>)
            //    .then(data => {
            //        if (data) {
            //                Isdisabled = false;
            //        }
            //        else {
            //                Isdisabled = true;
            //        }
            //    });
        }

        if (selectedReeferData.length > 1) {
            var isAssignCargo = selectedReeferData[0].IsCargoCare;
            if (cmdStr === "CurrentDetails" || cmdStr === "ShowPreTripResults" || cmdStr === "ConfirmControllerSwap" || cmdStr === "BookingandAccess" || cmdStr === "NewBookingandAccess" || cmdStr === "ChangeReeferID" || cmdStr === "ShowTripWISEReport") {
                Isdisabled = true;
            }

            if (isGuestFound.length > 0) {
                if (cmdStr === "SetReportingInterval")
                    Isdisabled = true;

            }
            if (selectedReeferData[0].TripStatusCd != null) {
                if (dflag) {
                    if (cmdStr === "ClearDeviation")
                        Isdisabled = false;
                } else {
                    if (cmdStr === "ClearDeviation")
                        Isdisabled = true;
                }
            }
            else {
                if (cmdStr === "ClearDeviation")
                    Isdisabled = true;
            }
            if (isAssignCargo) {
                if (cmdStr === "UnassignfromCargoCare")
                    Isdisabled = false;
                if (cmdStr === "AssigntoCargoCare")
                    Isdisabled = true;
            }
            else {
                if (cmdStr === "UnassignfromCargoCare")
                    Isdisabled = true;
                if (cmdStr === "AssigntoCargoCare")
                    Isdisabled = false;
            }
            if (cmdStr === 'Humidity') {
                if ((isCT4Found > 0 || isDeviceTypeFound > 0) && (isDeviceTypeFound + isCT4Found) != selectedReeferData.length) {
                    Isdisabled = true;
                }
            }

        }
        else {
            var ReeferOEMTypeCd = "";
            var dflag = selectedReeferData[0].DeviationFlg;
            var csflag = selectedReeferData[0].ControllerSerialNumberChgFlag;
            var isAssignCargo = selectedReeferData[0].IsCargoCare;
            if (selectedReeferData[0].ReeferOEMTypeCd != null)
                ReeferOEMTypeCd = selectedReeferData[0].ReeferOEMTypeCd;
            if (ReeferOEMTypeCd != null && ReeferOEMTypeCd != undefined && ReeferOEMTypeCd != '') {
                if (ReeferOEMTypeCd.toString().trim() == 'U') {
                    if (cmdStr === "Defrost" || cmdStr === "StartPre-Trip" || cmdStr === "StopPre-Trip")
                        Isdisabled = true;
                }
                if (ReeferOEMTypeCd.trim() == 'TR') {
                    if (cmdStr === "Verify")
                        Isdisabled = true;
                }
                if ((ReeferOEMTypeCd.trim() == 'S') || (ReeferOEMTypeCd.trim() == 'T')) {
                    if (cmdStr === "ChgDefrostInterval")
                        Isdisabled = true;
                }
                if (ReeferOEMTypeCd.trim() == 'C' && (isGuestFound.length > 0)) {
                    if (cmdStr === "ChgDefrostInterval")
                        Isdisabled = true;
                }
                if (ReeferOEMTypeCd.trim() == 'T' || ReeferOEMTypeCd.trim() == 'U') {
                    if (cmdStr === "ShowPreTripResults") {
                        if (ReeferOEMTypeCd.trim() == 'T') {
                            if (selectedReeferData[0].OEMModel != null && selectedReeferData[0].OEMModel != undefined && selectedReeferData[0].OEMModel != '') {
                                if (selectedReeferData[0].OEMModel != 'MP3000' && selectedReeferData[0].OEMModel != 'MP3000A') {
                                    Isdisabled = true;
                                }
                            }
                            else
                                Isdisabled = true;
                        }
                        else
                            Isdisabled = true;
                    }
                }
            }
            else {
                if (cmdStr === "ShowPreTripResults")
                    Isdisabled = true;
            }
            if (cmdStr === "Unassign") {
                Isdisabled = true;

                var validateBookingID = false; var EventCd = ""
                if (selectedReeferData[0].BookingNumber != null) {
                    var eventDescription = lodashfilter(EventMasterList, function (item) {
                        return item.EventMasterID === selectedReeferData[0].EventMasterID;
                    });
                    if (eventDescription.length > 0 && eventDescription != null) {
                        EventCd = eventDescription[0].EventCd;
                    }
                }
                if (selectedReeferData[0].BookingNumber != null && EventCd != "BDR") {
                    Isdisabled = false;
                }
                else {
                    if (selectedReeferData != null && selectedReeferData != undefined) {
                        if (selectedReeferData[0].CustomerName != "") {
                            if (selectedReeferData[0].CustomerName === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName) {
                                Isdisabled = true;
                            } else {
                                Isdisabled = false;
                            }
                        }
                    }
                }
            }
            if (cmdStr === "NewBookingEdit" || cmdStr === "ViewBooking") {
                Isdisabled = true;

                var validateBookingID = false; var EventCd = ""
                if (selectedReeferData[0].BookingNumber != null) {
                    var eventDescription = lodashfilter(EventMasterList, function (item) {
                        return item.EventMasterID === selectedReeferData[0].EventMasterID;
                    });
                    if (eventDescription.length > 0 && eventDescription != null) {
                        EventCd = eventDescription[0].EventCd;
                    }
                }
                if (selectedReeferData[0].BookingNumber != null && EventCd != "BDR") {
                    Isdisabled = false;
                }
            }
            if (cmdStr === "NewBookingCreate") {
                Isdisabled = true;
                var EventCd = ""
                if (selectedReeferData[0].BookingNumber != null) {
                    var eventDescription = lodashfilter(EventMasterList, function (item) {
                        return item.EventMasterID === selectedReeferData[0].EventMasterID;
                    });
                    if (eventDescription.length > 0 && eventDescription != null) {
                        EventCd = eventDescription[0].EventCd;
                    }
                    if (EventCd == "BDR")
                        Isdisabled = false;
                    else
                        Isdisabled = true;
                }
                else
                    Isdisabled = false;

            }
            if (isAssignCargo) {
                if (cmdStr === "UnassignfromCargoCare")
                    Isdisabled = false;
                if (cmdStr === "AssigntoCargoCare")
                    Isdisabled = true;
            }
            else {
                if (cmdStr === "UnassignfromCargoCare")
                    Isdisabled = true;
                if (cmdStr === "AssigntoCargoCare")
                    Isdisabled = false;
            }
            if (csflag) {
                if (cmdStr === "ConfirmControllerSwap")
                    Isdisabled = false;
            }
            if (selectedReeferData[0].TripStatusCd != null) {
                if (dflag) {
                    if (cmdStr === "ClearDeviation")
                        Isdisabled = false;
                } else {
                    if (cmdStr === "ClearDeviation")
                        Isdisabled = true;
                }
            } else {
                if (cmdStr === "ClearDeviation")
                    Isdisabled = true;
            }

        }
        return Isdisabled;
    },
    checkMenuItemDisassociate(params, cmdStr) {
        var Isdisabled = false;
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });
        var isActiveAssociation = selectedReeferData[0].IsActive;
        if (isActiveAssociation == "Active") {
            if (cmdStr === "Disassociate")
                Isdisabled = false;
        }
        else {
            if (cmdStr === "Disassociate")
                Isdisabled = true;
        }
        return Isdisabled;
    },
    checkMenuItemVisibilityMultiple: (params: string) => {
        var configState = false;
        var visibilitySetting = [];
        var userRights: any = sessionStorage.getItem('userRights');
        var rights = JSON.parse(userRights);
        var paramsArray = params.split(',').map(function (item) {
            return parseInt(item, 10);
        });

        if (rights != null && rights != undefined) {
            if (params.length > 0) {
                $.each(paramsArray, function (i, j) {
                    var m = $.inArray(j.toString(), rights);
                    if (m != -1) {
                        configState = true;
                    }
                });
            }
        }

        if (!configState) {
            visibilitySetting.push('hidden');
        }

        return visibilitySetting;
    },
    checkMenuItemVisibilityMultipleInventory: (params: string, params2: any, menuItemName: string) => {
        var configState = false;
        var visibilitySetting = [];
        var userRights: any = sessionStorage.getItem('userRights');
        var rights = JSON.parse(userRights);
        var paramsArray = params.split(',').map(function (item) {
            return parseInt(item, 10);
        });

        if (rights != null && rights != undefined) {
            if (params.length > 0) {
                $.each(paramsArray, function (i, j) {
                    var m = $.inArray(j.toString(), rights);
                    if (m != -1) {
                        configState = true;
                    }
                });
            }
        }

        if (!configState) {
            visibilitySetting.push('hidden');
        }
        else if (configState) {
            //RCNG-41 start
            var selectedReeferData: any = [];
            var selectedRows = params2.api.getSelectedRows();
            selectedRows.forEach(function (selectedRow, index) {
                selectedReeferData.push(selectedRow);
            });
            var isActiveFound = 0;
            var isDisconnectedFound = 0;
            var isRetiredFound = 0;
            $.each(selectedReeferData, function (i, val) {
                if (val.AssetState != null && val.AssetState != undefined) {
                    if (val.AssetState.toString().trim() == 'A') {
                        isActiveFound = isActiveFound + 1;
                    }
                    if (val.AssetState.toString().trim() == 'D') {
                        isDisconnectedFound = isDisconnectedFound + 1;
                    }
                    if (val.AssetState.toString().trim() == 'R') {
                        isRetiredFound = isRetiredFound + 1;
                    }
                }
            });
            if ((isActiveFound > 0 || isDisconnectedFound > 0) && menuItemName == "Reactivate") {
                visibilitySetting.push('hidden');
            }
            else if (isRetiredFound > 0 && menuItemName == "Retire") {
                visibilitySetting.push('hidden');
            }
            else if ((isActiveFound > 0 || isDisconnectedFound > 0) && isRetiredFound > 0) {
                visibilitySetting.push('hidden');
            }
            //RCNG-41 end

            //if (params2 != null && params2 != undefined && params2.node != null && params2.node != undefined
            //    && params2.node.data != null && params2.node.data != undefined) {

            //    if (menuItemName == "Reactivate" &&
            //        (params2.node.data.AssetState === "A" || params2.node.data.AssetState === "D")) {
            //        visibilitySetting.push('hidden');
            //    }
            //    else if (menuItemName == "Retire" && params2.node.data.AssetState === "R"){
            //        visibilitySetting.push('hidden');
            //    }

            //}

        }

        return visibilitySetting;
    },
    checkCommandMenuItemVisibilityMultiple: (param1: string, param2: any) => {
        var configState = false;
        var visibilitySetting = [];
        var userRights: any = sessionStorage.getItem('userRights');
        var rights = JSON.parse(userRights);
        var paramsArray = param1.split(',').map(function (item) {
            return parseInt(item, 10);
        });

        if (rights != null && rights != undefined) {
            if (param1.length > 0) {
                $.each(paramsArray, function (i, j) {
                    var m = $.inArray(j.toString(), rights);
                    if (m != -1) {
                        configState = true;
                    }
                });
            }
        }

        {
            var isST9100Present = false;
            var selectedReeferData = [];
            var selectedRows = param2.api.getSelectedRows();
            selectedRows.forEach(function (selectedRow, index) {
                selectedReeferData.push(selectedRow);
            });
            $.each(selectedReeferData, function (i, val) {
                if (val.DeviceType != null && val.DeviceType != undefined) {
                    if (val.DeviceType.toString().trim() == 'ST9100') {
                        isST9100Present = true;
                    }
                }
            });
        }
        if (!configState || isST9100Present) {
            visibilitySetting.push('hidden');
        }

        return visibilitySetting;
    },
    checkMenuItemDisabledForCommands: (param1: any, param2: string) => { // Added this methos for RCNG-1842
        var Isdisabled = false;
        var isArrowspotPresent = false;
        var selectedReeferData = [];
        var selectedRows = param1.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });
        $.each(selectedReeferData, function (i, val) {
            if (val.DeviceType != null && val.DeviceType != undefined) {
                if (val.DeviceType.toString().trim().toUpperCase() == 'ARROWTRACK' || val.DeviceType.toString().trim().toUpperCase() == 'CT1000') {//RCNG-1932  //RCNG-2591
                    isArrowspotPresent = true;
                }
            }
        });

        if (isArrowspotPresent) {
            Isdisabled = true;
        }

        return Isdisabled;
    },
    //RCNG-3056
    checkMenuItemDisabledForLynxCommands: (param1: any, param2: string, enableLynxCommands: boolean, enableCT35ML5Commands: boolean, refControllertypes: any) => { // Added this methos for RCNG-1842
        var Isdisabled = false;
        var isArrowspotPresent = false;
        var isLynxPresent = false;
        var isCT35ML5Present = false;
        var isCT36ML5Present = false;
        var selectedReeferData = [];
        var selectedRows = param1.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });
        $.each(selectedReeferData, function (i, val) {
            if (val.DeviceType != null && val.DeviceType != undefined) {
                if (val.DeviceType.toString().trim().toUpperCase() == 'ARROWTRACK' || val.DeviceType.toString().trim().toUpperCase() == 'CT1000') {//RCNG-1932  //RCNG-2591
                    isArrowspotPresent = true;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'TRIPLINK') {//RCNG-3056
                        isLynxPresent = true;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'CT3500') {//RCNG-3425  //IOT Token ML5 on CT 35/36
                    var controllerDesc = "";
                    var controllertype = lodashfilter(refControllertypes, function (item) {
                        return item.ControllerTypeCd === val.ControllerTypeCd;
                    });
                    if (controllertype.length > 0 && controllertype != null) {
                        controllerDesc = controllertype[0].ControllerDesc;
                    }
                    if (controllerDesc == 'ML5')
                        isCT35ML5Present = true;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'CT3600') {//RCNG-3425  //IOT Token ML5 on CT 35/36
                    var controllerDesc = "";
                    var controllertype = lodashfilter(refControllertypes, function (item) {
                        return item.ControllerTypeCd === val.ControllerTypeCd;
                    });
                    if (controllertype.length > 0 && controllertype != null) {
                        controllerDesc = controllertype[0].ControllerDesc;
                    }
                    if (controllerDesc == 'ML5')
                        isCT36ML5Present = true;
                }
            }
        });

        if (isArrowspotPresent) {
            Isdisabled = true;
            return Isdisabled;
        }
        if (isLynxPresent) {
            if (enableLynxCommands)
                Isdisabled = false;
            else {
                Isdisabled = true;
                return Isdisabled;
            }
        }
        if (isCT35ML5Present) {
            if (enableCT35ML5Commands)
                Isdisabled = false;
            else {
                Isdisabled = true;
                return Isdisabled;
            }
        }
        if (isCT36ML5Present) {
                Isdisabled = false;
                return Isdisabled;
        }
        return Isdisabled;
    },
    checkMenuItemDisabledForRcdCommands: (param1: any, param2: string, enableLynxCommands: boolean, enableCT35ML5Commands: boolean) => { // Added this methos for RCNG-1842
        var Isdisabled = false;
        var isArrowspotPresent = false;
        var isCT35ML5Present = false;
        var isCT36ML5Present = false;
        var selectedReeferData = [];
        var selectedRows = param1.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });
        $.each(selectedReeferData, function (i, val) {
            if (val.DeviceType != null && val.DeviceType != undefined) {
                if (val.DeviceType.toString().trim().toUpperCase() == 'ARROWTRACK' || val.DeviceType.toString().trim().toUpperCase() == 'CT1000' || val.DeviceType.toString().trim().toUpperCase() == 'CT1010') {//RCNG-1932  //RCNG-2591
                    isArrowspotPresent = true;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'TRIPLINK') {//RCNG-1932  //RCNG-2591
                    if (enableLynxCommands == false)
                        isArrowspotPresent = true;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'SEKSTANT') {//RCNG-3429
                    isArrowspotPresent = true;
                }
                //RCNG-3425
                if ((val.DeviceType.toString().trim().toUpperCase() == 'CT3500' || val.DeviceType.toString().trim().toUpperCase() == 'CT3600') && val.ControllerDesc.toString().trim().toUpperCase() == 'ML5') { //IOT Token ML5 on CT 35 / 36
                    //if (enableCT35ML5Commands == false)
                        isArrowspotPresent = true;
                }
            }
        });

        if (isArrowspotPresent) {
            Isdisabled = true;
        }
        return Isdisabled;
    },

    checkMenuItemDisabledForDryEditAsset: (param1: any) => {
        var Isdisabled = false;
        var isDryAssetPresent = false;
        var selectedReeferData = [];
        var selectedRows = param1.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });
        $.each(selectedReeferData, function (i, val) {
            if (val.DeviceType != null && val.DeviceType != undefined) {
                if (val.DeviceType.toString().trim().toUpperCase() == 'CT1000' || val.DeviceType.toString().trim().toUpperCase() == 'CT1010') {//RCNG-1932  //RCNG-3860
                    isDryAssetPresent = true;
                }
            }
        });

        if (!isDryAssetPresent) {
            Isdisabled = true;
        }

        return Isdisabled;
    },
    checkMenuItemVisibilityMultipleByData: (rightId: string, params, cmdStr, refControllertypes: any) => {
        var visibilitySetting = [];
        var dCXDownloads;
        dCXDownloads = JSON.parse(sessionStorage.getItem('customerDetails')).DCXDownloads;
        var hide = false;
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });
        var isDeviceTypeFound = 0;
        var isCT4Found = 0;
        var isSekstantFound = 0;
        var isLynxFound = 0;
        var isCT35ML5Found = 0;
        var isCT36ML5Found = 0;
        var isZestiaModelFound = 0;
        $.each(selectedReeferData, function (i, val) {
            if (val.DeviceType != null && val.DeviceType != undefined) {
                if (val.DeviceType.toString().trim() == 'CT5000') {
                    isDeviceTypeFound = isDeviceTypeFound + 1;
                }
                if (val.DeviceType.toString().trim() == 'CT4000') {
                    isCT4Found = isCT4Found + 1;
                }
                //if (val.DeviceType.toString().trim() == 'CT4000') {
                //    isCT4Found = isCT4Found + 1;
                //}
                if (val.DeviceType.toString().trim() == 'Sekstant') {
                    isSekstantFound = isSekstantFound + 1;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'TRIPLINK') {
                    isLynxFound = isLynxFound + 1;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'CT3500') { //IOT Token ML5 on CT 35/36
                    var controllerDesc = "";
                    var controllertype = lodashfilter(refControllertypes, function (item) {
                        return item.ControllerTypeCd === val.ControllerTypeCd;
                    });
                    if (controllertype.length > 0 && controllertype != null) {
                        controllerDesc = controllertype[0].ControllerDesc;
                    }
                    if (controllerDesc == 'ML5')
                        isCT35ML5Found = isCT35ML5Found+1;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'CT3600') { //IOT Token ML5 on CT 35/36
                    var controllerDesc = "";
                    var controllertype = lodashfilter(refControllertypes, function (item) {
                        return item.ControllerTypeCd === val.ControllerTypeCd;
                    });
                    if (controllertype.length > 0 && controllertype != null) {
                        controllerDesc = controllertype[0].ControllerDesc;
                    }
                    if (controllerDesc == 'ML5')
                        isCT36ML5Found = isCT36ML5Found + 1;
                }
                if (val.ReeferOEMTypeCd != null && val.ReeferOEMTypeCd != undefined) {
                    if (val.ReeferOEMTypeCd.trim().toUpperCase() == 'D') {
                        if (val.UnitTypeCd != null && val.UnitTypeCd != undefined && val.UnitTypeCd != '') {
                            if (val.UnitTypeCd.trim().toUpperCase() == 'DV' || val.UnitTypeCd.trim().toUpperCase() == 'DA' || val.UnitTypeCd.trim().toUpperCase() == 'DB') {
                                isZestiaModelFound = isZestiaModelFound + 1;
                            }
                        }
                    }
                }
            }
        });
        if (isCT4Found > 0) {
            var eligibleForShow = ['ChangeSetpoints', 'Defrost'];
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['QueryReeferInventory', 'GuestReeferconfiguration', 'FreshAirType', 'Clock', 'ReeferModelConfiguration'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }

        }
        if (isLynxFound > 0) {
            var eligibleForShow = ['ChangeSetpoints', 'Defrost', 'ReeferPreTrip', 'ReeferDataLog'];
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['QueryReeferInventory', 'GuestReeferconfiguration', 'FreshAirType', 'Clock',
                'ReeferModelConfiguration', 'Reporting'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }

        }
        if (isDeviceTypeFound > 0) {
            var eligibleForShow = ['ChangeSetpoints', 'Defrost'];
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['QueryReeferInventory', 'GuestReeferconfiguration', 'FreshAirType', 'Clock', 'ReeferDataLog', 'ReeferModelConfiguration', 'ReeferPreTrip'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }

        }

        if (isSekstantFound > 0) {
            var eligibleForShow = ['ChangeSetpoints', 'ReeferDataLog'];
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['Reporting', 'Defrost', 'QueryReeferInventory', 'GuestReeferconfiguration', 'FreshAirType', 'Clock', 'ReeferModelConfiguration', 'ReeferPreTrip'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }
        }
        if (isCT35ML5Found > 0) {
            var eligibleForShow = ['ChangeSetpoints', 'Defrost'];
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['Reporting','QueryReeferInventory', 'GuestReeferconfiguration', 'FreshAirType', 'Clock', 'ReeferDataLog', 'ReeferModelConfiguration', 'ReeferPreTrip'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }

        }
        if (isCT36ML5Found > 0) {
            var eligibleForShow = ['ChangeSetpoints', 'Defrost', 'ReeferDataLog'];
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['Reporting', 'QueryReeferInventory', 'GuestReeferconfiguration', 'FreshAirType', 'Clock', 'ReeferModelConfiguration', 'ReeferPreTrip'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }

        }
        var customerTypeCd = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerTypeCd;
        var eligibleForHide = ['GuestReeferconfiguration', 'ChangeZigbeeConfigSettings', 'AssignPANId', 'DeviceConfiguration', 'AssetConfiguration'];
        if (eligibleForHide.indexOf(cmdStr) !== -1 && customerTypeCd != "SO") {
            hide = true;
        }
        if (selectedReeferData.length > 1) {
            if (selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() != 'C').length)) {
                var eligibleForHide = ['ReeferModelConfiguration'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() != 'S').length)) {
                var eligibleForHide = ['FreshAirType'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }


        } else {
            var ReeferOEMTypeCd = "";
            if (selectedReeferData[0].ReeferOEMTypeCd != null)
                ReeferOEMTypeCd = selectedReeferData[0].ReeferOEMTypeCd;
            if (ReeferOEMTypeCd != null && ReeferOEMTypeCd != undefined && ReeferOEMTypeCd.toString().trim() != 'C') {
                var eligibleForHide = ['ReeferModelConfiguration'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (ReeferOEMTypeCd != null && ReeferOEMTypeCd != undefined && ReeferOEMTypeCd.toString().trim() != 'S') {
                var eligibleForHide = ['FreshAirType'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
        }
        //if (isZestiaModelFound == 0 || isZestiaModelFound != selectedReeferData.length) {
        //    var eligibleForHide = ['OEMPTI'];
        //    if (eligibleForHide.indexOf(cmdStr) !== -1) {
        //        hide = true;
        //    }
        //}
        var userRights: any = sessionStorage.getItem('userRights');
        var rights = JSON.parse(userRights);
        var configState = false;
        var paramsArray = rightId.split(',').map(function (item) {
            return parseInt(item, 10);
        });

        if (rights != null && rights != undefined) {
            if (rightId.length > 0) {
                $.each(paramsArray, function (i, j) {
                    var m = $.inArray(j.toString(), rights);
                    if (m != -1) {
                        configState = true;
                    }
                });
            }
        }

        if (!configState) {
            visibilitySetting.push('hidden');
        }
        if (configState && hide) {
            visibilitySetting.push('hidden');
        }

        return visibilitySetting;
    },
    checkMenuItemVisibilityMultipleByDataForTDD: (rightId: string, params, cmdStr, refControllertypes: any, ShowTDDForCT36ML5: boolean, ShowTDDForCT35ML5: boolean) => {
        var visibilitySetting = [];
        var dCXDownloads;
        dCXDownloads = JSON.parse(sessionStorage.getItem('customerDetails')).DCXDownloads;
        var hide = false;
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });
        var isDeviceTypeFound = 0;
        var isCT4Found = 0;
        var isSekstantFound = 0;
        var isLynxFound = 0;
        var isCT35ML5Found = 0;
        var isCT36ML5Found = 0;
        var isZestiaModelFound = 0;
        $.each(selectedReeferData, function (i, val) {
            if (val.DeviceType != null && val.DeviceType != undefined) {
                if (val.DeviceType.toString().trim() == 'CT5000') {
                    isDeviceTypeFound = isDeviceTypeFound + 1;
                }
                if (val.DeviceType.toString().trim() == 'CT4000') {
                    isCT4Found = isCT4Found + 1;
                }
                //if (val.DeviceType.toString().trim() == 'CT4000') {
                //    isCT4Found = isCT4Found + 1;
                //}
                if (val.DeviceType.toString().trim() == 'Sekstant') {
                    isSekstantFound = isSekstantFound + 1;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'TRIPLINK') {
                    isLynxFound = isLynxFound + 1;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'CT3500') { //IOT Token ML5 on CT 35/36
                    var controllerDesc = "";
                    var controllertype = lodashfilter(refControllertypes, function (item) {
                        return item.ControllerTypeCd === val.ControllerTypeCd;
                    });
                    if (controllertype.length > 0 && controllertype != null) {
                        controllerDesc = controllertype[0].ControllerDesc;
                    }
                    if (controllerDesc == 'ML5')
                        isCT35ML5Found = isCT35ML5Found + 1;
                }
                if (val.DeviceType.toString().trim().toUpperCase() == 'CT3600') { //IOT Token ML5 on CT 35/36
                    var controllerDesc = "";
                    var controllertype = lodashfilter(refControllertypes, function (item) {
                        return item.ControllerTypeCd === val.ControllerTypeCd;
                    });
                    if (controllertype.length > 0 && controllertype != null) {
                        controllerDesc = controllertype[0].ControllerDesc;
                    }
                    if (controllerDesc == 'ML5')
                        isCT36ML5Found = isCT36ML5Found + 1;
                }
                if (val.ReeferOEMTypeCd != null && val.ReeferOEMTypeCd != undefined) {
                    if (val.ReeferOEMTypeCd.trim().toUpperCase() == 'D') {
                        if (val.UnitTypeCd != null && val.UnitTypeCd != undefined && val.UnitTypeCd != '') {
                            if (val.UnitTypeCd.trim().toUpperCase() == 'DV' || val.UnitTypeCd.trim().toUpperCase() == 'DA' || val.UnitTypeCd.trim().toUpperCase() == 'DB') {
                                isZestiaModelFound = isZestiaModelFound + 1;
                            }
                        }
                    }
                }
            }
        });
        if (isCT4Found > 0) {
            var eligibleForShow = ['ChangeSetpoints', 'Defrost'];
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['QueryReeferInventory', 'GuestReeferconfiguration', 'FreshAirType', 'Clock', 'ReeferModelConfiguration'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }

        }
        if (isLynxFound > 0) {
            var eligibleForShow = ['ChangeSetpoints', 'Defrost', 'ReeferPreTrip', 'ReeferDataLog'];
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['QueryReeferInventory', 'GuestReeferconfiguration', 'FreshAirType', 'Clock',
                'ReeferModelConfiguration', 'Reporting'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }

        }
        if (isDeviceTypeFound > 0) {
            var eligibleForShow = ['ChangeSetpoints', 'Defrost'];
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['QueryReeferInventory', 'GuestReeferconfiguration', 'FreshAirType', 'Clock', 'ReeferDataLog', 'ReeferModelConfiguration', 'ReeferPreTrip'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }

        }

        if (isSekstantFound > 0) {
            var eligibleForShow = ['ChangeSetpoints', 'ReeferDataLog'];
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['Reporting', 'Defrost', 'QueryReeferInventory', 'GuestReeferconfiguration', 'FreshAirType', 'Clock', 'ReeferModelConfiguration', 'ReeferPreTrip'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }
        }
        if (isCT35ML5Found > 0) {
            var eligibleForShow = ['ChangeSetpoints', 'Defrost', 'ReeferDataLog'];
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['Reporting', 'QueryReeferInventory', 'GuestReeferconfiguration', 'FreshAirType', 'Clock', 'ReeferModelConfiguration', 'ReeferPreTrip'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }
            if (cmdStr === 'ReeferDataLog') {
                if (!ShowTDDForCT35ML5)
                    hide = true;
            }

        }
        if (isCT36ML5Found > 0) {
            var eligibleForShow = ['ChangeSetpoints', 'Defrost', 'ReeferDataLog'];
            if (eligibleForShow.indexOf(cmdStr) !== -1) {
                hide = false;
            }
            var eligibleForHide = ['Reporting', 'QueryReeferInventory', 'GuestReeferconfiguration', 'FreshAirType', 'Clock', 'ReeferModelConfiguration', 'ReeferPreTrip'];
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }
            if (cmdStr === 'ReeferDataLog') {
                if (!ShowTDDForCT36ML5)
                    hide = true;
            }
        }
        var customerTypeCd = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerTypeCd;
        var eligibleForHide = ['GuestReeferconfiguration', 'ChangeZigbeeConfigSettings', 'AssignPANId', 'DeviceConfiguration', 'AssetConfiguration'];
        if (eligibleForHide.indexOf(cmdStr) !== -1 && customerTypeCd != "SO") {
            hide = true;
        }
        if (selectedReeferData.length > 1) {
            if (selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() != 'C').length)) {
                var eligibleForHide = ['ReeferModelConfiguration'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (selectedReeferData.length == (selectedReeferData.filter(row => row.ReeferOEMTypeCd && row.ReeferOEMTypeCd.trim() != 'S').length)) {
                var eligibleForHide = ['FreshAirType'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }


        } else {
            var ReeferOEMTypeCd = "";
            if (selectedReeferData[0].ReeferOEMTypeCd != null)
                ReeferOEMTypeCd = selectedReeferData[0].ReeferOEMTypeCd;
            if (ReeferOEMTypeCd != null && ReeferOEMTypeCd != undefined && ReeferOEMTypeCd.toString().trim() != 'C') {
                var eligibleForHide = ['ReeferModelConfiguration'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
            if (ReeferOEMTypeCd != null && ReeferOEMTypeCd != undefined && ReeferOEMTypeCd.toString().trim() != 'S') {
                var eligibleForHide = ['FreshAirType'];
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
        }
        //if (isZestiaModelFound == 0 || isZestiaModelFound != selectedReeferData.length) {
        //    var eligibleForHide = ['OEMPTI'];
        //    if (eligibleForHide.indexOf(cmdStr) !== -1) {
        //        hide = true;
        //    }
        //}
        var userRights: any = sessionStorage.getItem('userRights');
        var rights = JSON.parse(userRights);
        var configState = false;
        var paramsArray = rightId.split(',').map(function (item) {
            return parseInt(item, 10);
        });

        if (rights != null && rights != undefined) {
            if (rightId.length > 0) {
                $.each(paramsArray, function (i, j) {
                    var m = $.inArray(j.toString(), rights);
                    if (m != -1) {
                        configState = true;
                    }
                });
            }
        }

        if (!configState) {
            visibilitySetting.push('hidden');
        }
        if (configState && hide) {
            visibilitySetting.push('hidden');
        }

        return visibilitySetting;
    },
    checkMenuItemVisibilityForDeviceStatus: (rightId: string, params, cmdStr) => {
        var visibilitySetting = [];
        var hide = false;
        var selectedReeferData = [];
        var Isdisabled = false;
        var selectedRows = params.api.getSelectedRows();
        var isDeviceTypeFound = 0;
        var isCT4Found = 0;
        var isM2C = 0;
        var IsDryDevice = 0;
        var isFromVessel = 0;
        var isGuestFound;
        var isST9100Device = 0;
        var isGT1030Device = 0;
        if (selectedRows[0].DeviceType != null && selectedRows[0].DeviceType != undefined) {
            if (selectedRows[0].DeviceType.toString().trim() == 'WG1' || selectedRows[0].DeviceType.toString().trim() == 'WG2' || selectedRows[0].DeviceType.toString().trim() == 'X47' || selectedRows[0].DeviceType.toString().trim() == 'X48') {
                isM2C = isM2C + 1;
            }
            if (selectedRows[0].DeviceType.toString().trim() == 'X47' || selectedRows[0].DeviceType.toString().trim() == 'X48' || selectedRows[0].DeviceType.toString().trim() == 'GT1200' || selectedRows[0].DeviceType.toString().trim() == 'GT1020') {
                IsDryDevice = IsDryDevice + 1;
            }
            if (selectedRows[0].DeviceType.toString().trim() == 'CT5000') {
                isDeviceTypeFound = isDeviceTypeFound + 1;
            }
            if (selectedRows[0].DeviceType.toString().trim() == 'CT4000') {
                isCT4Found = isCT4Found + 1;
                if (selectedRows[0].VesselCd != undefined && selectedRows[0].VesselCd != null)
                    isFromVessel = isFromVessel + 1;
            }
            if (selectedRows[0].DeviceType.toString().trim() == 'ST9100') {
                isST9100Device = isST9100Device + 1;
            }
            if (selectedRows[0].DeviceType.toString().trim() == 'GT1030') {
                isGT1030Device = isGT1030Device + 1;
            }
        }
        isGuestFound = selectedRows.filter(row => row.DeviceConfig == true);
        if ((IsDryDevice > 0 || isST9100Device > 0 || isGT1030Device > 0) && cmdStr == 'Commands') {
            hide = true;
        }
        else {
            if (cmdStr == 'Device Reset To Defaults') {
                if (isDeviceTypeFound > 0 || isM2C > 0)
                    hide = true;
            }
            if (cmdStr == 'Reporting Interval') {
                if (isDeviceTypeFound > 0 || isM2C > 0 || isGuestFound.length > 0)
                    hide = true;
            }
            if (cmdStr == 'Device Reset') {
                if (isM2C > 0)
                    hide = true;
            }
            if (cmdStr == 'Get Asset ID') {
                if (!(isCT4Found > 0 && isFromVessel <= 0))//isDeviceTypeFound > 0 ||
                    hide = true;
            }
            if (cmdStr == 'Assign PAN Id') {
                if (isCT4Found > 0 || isDeviceTypeFound > 0 || isM2C > 0 || JSON.parse(sessionStorage.getItem('customerDetails')).CustomerTypeCd != 'SO')
                    hide = true;
            }
            if (cmdStr == 'Device Configuration') {
                if (isDeviceTypeFound > 0 || isM2C > 0 || JSON.parse(sessionStorage.getItem('customerDetails')).CustomerTypeCd != 'SO')
                    hide = true;
            }
            if (cmdStr == 'Assign') {
                if (JSON.parse(sessionStorage.getItem('customerDetails')).CustomerTypeCd != 'SO')
                    hide = true;
            }
        }

        if (rightId == null) {
            if (hide) {
                visibilitySetting.push('hidden');
            }
        }
        else {
            var userRights: any = sessionStorage.getItem('userRights');
            var rights = JSON.parse(userRights);
            var configState = false;
            var paramsArray = rightId.split(',').map(function (item) {
                return parseInt(item, 10);
            });
            if (rights != null && rights != undefined) {
                if (rightId.length > 0) {
                    $.each(paramsArray, function (i, j) {
                        var m = $.inArray(j.toString(), rights);
                        if (m != -1) {
                            configState = true;
                        }
                    });
                }
            }

            if (!configState) {
                //visibilitySetting.push('hidden');
                visibilitySetting.push('d-none');
            }
            if (configState && hide) {
                //visibilitySetting.push('hidden');
                visibilitySetting.push('d-none');
            }
        }
        return visibilitySetting;
    },

    checkMenuItemDisabledFromCCProfileStatus(params, cmdStr) {
        var Isdisabled = false;
        var selectedRowData = [];
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedRowData.push(selectedRow);
        });
        if (selectedRowData.length > 1) {
            var isActiveFound;
            isActiveFound = selectedRowData.filter(row => row.StateCd == 'A');
            var isInActiveFound;
            isInActiveFound = selectedRowData.filter(row => row.StateCd == 'I');
            if (isActiveFound.length > 0 && isInActiveFound.length > 0) {
                if (cmdStr == 'ActivateProfile')
                    Isdisabled = true;
                else if (cmdStr == 'DeactivateProfile')
                    Isdisabled = true;
                else if (cmdStr == 'DeleteProfile')
                    Isdisabled = true;

            }
            else if (isActiveFound.length > 0 && isInActiveFound.length == 0) {
                if (cmdStr == 'ActivateProfile')
                    Isdisabled = true;
                else if (cmdStr == 'DeactivateProfile')
                    Isdisabled = false;
                else if (cmdStr == 'DeleteProfile')
                    Isdisabled = false;
            }
            else {
                if (cmdStr == 'ActivateProfile')
                    Isdisabled = false;
                else if (cmdStr == 'DeactivateProfile')
                    Isdisabled = true;
                else if (cmdStr == 'DeleteProfile')
                    Isdisabled = false;
            }
        }
        else {
            if (selectedRowData[0].StateCd == 'A') {
                if (cmdStr == 'ActivateProfile')
                    Isdisabled = true;
                else if (cmdStr == 'DeactivateProfile')
                    Isdisabled = false;
                else if (cmdStr == 'DeleteProfile')
                    Isdisabled = false;
            }
            else if (selectedRowData[0].StateCd == 'I') {
                if (cmdStr == 'ActivateProfile')
                    Isdisabled = false;
                else if (cmdStr == 'DeactivateProfile')
                    Isdisabled = true;
                else if (cmdStr == 'DeleteProfile')
                    Isdisabled = false;
            }
            else {
                if (cmdStr == 'ActivateProfile')
                    Isdisabled = true;
                else if (cmdStr == 'DeactivateProfile')
                    Isdisabled = true;
                else if (cmdStr == 'DeleteProfile')
                    Isdisabled = true;
            }
        }

        return Isdisabled;
    },

    checkMenuItemDisabledFromGroupStatus(params, cmdStr) {
        var Isdisabled = false;
        var selectedRowData = [];
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedRowData.push(selectedRow);
        });

        if (selectedRowData.length > 1) {
            var isActiveFound;
            isActiveFound = selectedRowData.filter(row => row.IsActive == true);
            var isInActiveFound;
            isInActiveFound = selectedRowData.filter(row => row.IsActive == false);
            if (isActiveFound.length > 0 && isInActiveFound.length > 0) {
                if (cmdStr == 'ActivateGroup')
                    Isdisabled = true;
                else if (cmdStr == 'DeactivateGroup')
                    Isdisabled = true;
            }
            else if (isActiveFound.length > 0 && isInActiveFound.length == 0) {
                if (cmdStr == 'ActivateGroup')
                    Isdisabled = true;
                else if (cmdStr == 'DeactivateGroup')
                    Isdisabled = false;
            }
            else {
                if (cmdStr == 'ActivateGroup')
                    Isdisabled = false;
                else if (cmdStr == 'DeactivateGroup')
                    Isdisabled = true;
            }
        }
        else {
            if (selectedRowData[0].IsActive == true) {
                if (cmdStr == 'ActivateGroup')
                    Isdisabled = true;
                else if (cmdStr == 'DeactivateGroup')
                    Isdisabled = false;
            }
            else {
                if (cmdStr == 'ActivateGroup')
                    Isdisabled = false;
                else if (cmdStr == 'DeactivateGroup')
                    Isdisabled = true;
            }
        }

        return Isdisabled;
    },
    checkMenuItemDisabledFromUserstatus(params, cmdStr) {
        var Isdisabled = false;
        var selectedRowData = [];
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedRowData.push(selectedRow);
        });
        if (cmdStr == 'UpdateUser') {
            if (selectedRowData.length > 1)
                Isdisabled = true;
            else
                Isdisabled = false;
        }
        else {
            if (selectedRowData.length > 1) {
                var isActiveFound;
                isActiveFound = selectedRowData.filter(row => row.IsActive == true);
                var isInActiveFound;
                isInActiveFound = selectedRowData.filter(row => row.IsActive == false);
                if (isActiveFound.length > 0 && isInActiveFound.length > 0) {
                    if (cmdStr == 'ActivateUser')
                        Isdisabled = true;
                    else if (cmdStr == 'InactivateUser')
                        Isdisabled = true;
                    else if (cmdStr == 'ResetPassword')
                        Isdisabled = true;
                }
                else if (isActiveFound.length > 0 && isInActiveFound.length == 0) {
                    if (cmdStr == 'ActivateUser')
                        Isdisabled = true;
                    else if (cmdStr == 'InactivateUser')
                        Isdisabled = false;
                    else if (cmdStr == 'ResetPassword')
                        Isdisabled = false;
                }
                else {
                    if (cmdStr == 'ActivateUser')
                        Isdisabled = false;
                    else if (cmdStr == 'InactivateUser')
                        Isdisabled = true;
                    else if (cmdStr == 'ResetPassword')
                        Isdisabled = true;
                }
            }
            else {
                if (selectedRowData[0].IsActive == true) {
                    if (cmdStr == 'ActivateUser')
                        Isdisabled = true;
                    else if (cmdStr == 'InactivateUser')
                        Isdisabled = false;
                    else if (cmdStr == 'ResetPassword')
                        Isdisabled = false;
                }
                else {
                    if (cmdStr == 'ActivateUser')
                        Isdisabled = false;
                    else if (cmdStr == 'InactivateUser')
                        Isdisabled = true;
                    else if (cmdStr == 'ResetPassword')
                        Isdisabled = true;
                }
            }
        }
        return Isdisabled;
    },
    checkVisibilityInvisible: (params: string) => {
        var visibilitySetting = '';
        var userRights: any = sessionStorage.getItem('userRights');
        var rights = JSON.parse(userRights);
        if (rights != null && rights != undefined) {
            var rightValue = [parseInt(params)];
            var isValueExits = $.inArray(rightValue.toString(), rights);
            if (isValueExits == -1) {
                visibilitySetting = 'invisible';
            }
        }

        return visibilitySetting;
    },
    checkVisibilityMultipleInvisible: (params: string) => {
        var visibilitySetting = 'show';
        var userRights: any = sessionStorage.getItem('userRights');
        var rights = JSON.parse(userRights);
        var configState = false;
        var paramsArray = params.split(',').map(function (item) {
            return parseInt(item, 10);
        });

        if (rights != null && rights != undefined) {
            if (params.length > 0) {
                $.each(paramsArray, function (i, j) {
                    var m = $.inArray(j.toString(), rights);
                    if (m != -1) {
                        configState = true;
                    }
                });
            }
        }

        if (!configState) {
            visibilitySetting = 'invisible';
        }

        return visibilitySetting;
    },
    checkVisibilityMultiple: (params: string) => {
        var visibilitySetting = 'show';
        var userRights: any = sessionStorage.getItem('userRights');
        var isCustomAttributesEnable = JSON.parse(sessionStorage.getItem('UserInfo')).IsCustomAttributesEnable;
        var rights = JSON.parse(userRights);
        var configState = false;
        var paramsArray = params.split(',').map(function (item) {
            return parseInt(item, 10);
        });
        if (rights != null && rights != undefined) {
            if (params.length > 0) {

                $.each(paramsArray, function (i, j) {
                    var m = $.inArray(j.toString(), rights);
                    if (j == 164) {
                        if (m != -1 && isCustomAttributesEnable == true)
                            configState = true;
                    }
                    else {
                        if (m != -1) {
                            configState = true;
                        }
                    }
                });
            }
        }

        if (!configState) {
            visibilitySetting = 'hidden';
        }

        return visibilitySetting;
    },
    checkVisibilityMultipleInventory: (params: string) => {
        var visibilitySetting = 'show';
        visibilitySetting = 'hidden';
        return visibilitySetting;
    },
    checkMenuItemDisableForCommandStatus(params) {
        var isDisabled = false;
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();

        if (selectedRows.length != 0) {
            var selected = params.api.getFocusedCell();
            var selectedRow = params.api.getRowNode(selected.rowIndex);
            selectedRows.forEach(function (selectedRow, index) {
                selectedReeferData.push(selectedRow);
            });
        }

        var isCT4Found = 0;
        $.each(selectedReeferData, function (i, val) {
            if (val.DeviceType != null && val.DeviceType != undefined) {
                if (val.DeviceType.toString().trim() == 'CT4000') {
                    isCT4Found = isCT4Found + 1;
                }
            }
        });

        if (selectedReeferData.length > 1) {
            if (selectedReeferData.length == selectedReeferData.filter(row => row.Status.trim().toUpperCase() == 'AWAITINGPREREQUISITES' || row.Status.trim().toUpperCase() == 'PENDING' || row.Status.trim().toUpperCase() == 'RETRY' || row.Status.trim().toUpperCase() == 'AWAITINGSYNC'
                || row.Status.trim().toUpperCase() == 'SENTTOVC' || row.Status.trim().toUpperCase() == 'COMMANDACCEPTEDBYRCD').length) {
                if ((selectedReeferData.filter(row => row.Status.trim().toUpperCase() == 'PENDING' || row.Status.trim().toUpperCase() == 'RETRY').length > 0)
                    && (selectedReeferData.filter(row => (row.CommandTypeCd == 'DGS' || row.CommandTypeCd == 'RFR') && (row.DeviceType != null && row.DeviceType.toString().trim() == 'CT4000')).length > 0)
                ) { isDisabled = true; }
                else if ((selectedReeferData.filter(row => row.Status.trim().toUpperCase() == 'COMMANDACCEPTEDBYRCD').length > 0)
                    && (selectedReeferData.filter(row => (row.VesselCd == null)).length > 0)
                ) { isDisabled = true; }
                else
                    isDisabled = false;
            }
            else {
                isDisabled = true;
            }
        }
        else {
            var dflag = selectedReeferData[0].Status;
            var commandTypeCd = selectedReeferData[0].CommandTypeCd;
            var vesselCd = selectedReeferData[0].VesselCd;
            if (dflag.trim().toUpperCase() == 'AWAITINGPREREQUISITES' || dflag.trim().toUpperCase() == 'PENDING' || dflag.trim().toUpperCase() == 'RETRY' || dflag.trim().toUpperCase() == 'AWAITINGSYNC'
                || dflag.trim().toUpperCase() == 'SENTTOVC' || (dflag.trim().toUpperCase() == 'COMMANDACCEPTEDBYRCD' && vesselCd != null)) {
                if ((dflag.trim().toUpperCase() == 'PENDING' || dflag.trim().toUpperCase() == 'RETRY')
                    && (commandTypeCd == 'DGS' || commandTypeCd == 'RFR')
                    && isCT4Found > 0) { isDisabled = true; }
                else
                    isDisabled = false;
            } else {
                isDisabled = true;
            }
        }

        return isDisabled;
    },
    checkMenuDeploymentDetails(params) {
        var isDisabled = false;
        var selectedRows = params.api.getSelectedRows();
        if (selectedRows.length > 1)
            isDisabled = true;
        else
            isDisabled = false;

        return isDisabled;
    },
    checkMenuEditDeployment(params) {
        var isDisabled = false;
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();

        if (selectedRows.length > 1)
            return true;

        if (selectedRows.length != 0) {
            var selected = params.api.getFocusedCell();
            var selectedRow = params.api.getRowNode(selected.rowIndex);
            selectedRows.forEach(function (selectedRow, index) {
                selectedReeferData.push(selectedRow);
            });
        }

        var EditCnt = 0;
        $.each(selectedReeferData, function (index, item) {
            if (item.DeploymentStatus == "Pending" || item.DeploymentStatus == "In Progress") {
                EditCnt++;
            }
        });

        if (EditCnt == selectedReeferData.length) {
            isDisabled = false;
        }
        else {
            isDisabled = true;
        }

        return isDisabled;
    },
    checkMenuDeleteDeployment(params) {
        var isDisabled = false;
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();

        if (selectedRows.length != 0) {
            var selected = params.api.getFocusedCell();
            var selectedRow = params.api.getRowNode(selected.rowIndex);
            selectedRows.forEach(function (selectedRow, index) {
                selectedReeferData.push(selectedRow);
            });
        }

        var DeleteCnt = 0;
        $.each(selectedReeferData, function (index, item) {
            if (item.DeploymentStatus == "Pending") {
                DeleteCnt++;
            }
        });
        if (DeleteCnt == selectedReeferData.length) {
            isDisabled = false;
        }
        else {
            isDisabled = true;
        }

        return isDisabled;
    },
    checkMenuStopDeployment(params) {
        var isDisabled = false;
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();

        if (selectedRows.length != 0) {
            var selected = params.api.getFocusedCell();
            var selectedRow = params.api.getRowNode(selected.rowIndex);
            selectedRows.forEach(function (selectedRow, index) {
                selectedReeferData.push(selectedRow);
            });
        }

        var StopCnt = 0;
        $.each(selectedReeferData, function (index, item) {
            if (item.DeploymentStatus == "In Progress") {
                StopCnt++;
            }
        });

        if (StopCnt == selectedReeferData.length) {
            isDisabled = false;
        }
        else {
            isDisabled = true;
        }

        return isDisabled;
    },
    checkMenuStatisticsDeployment(params) {
        var isDisabled = false;
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();

        if (selectedRows.length > 1)
            return true;

        if (selectedRows.length != 0) {
            var selected = params.api.getFocusedCell();
            var selectedRow = params.api.getRowNode(selected.rowIndex);
            selectedRows.forEach(function (selectedRow, index) {
                selectedReeferData.push(selectedRow);
            });
        }

        var StatisticCnt = 0;
        $.each(selectedReeferData, function (index, item) {
            if (item.DeploymentStatus != "Pending") {
                StatisticCnt++;
            }
        });

        if (StatisticCnt == selectedReeferData.length) {
            isDisabled = false;
        }
        else {
            isDisabled = true;
        }

        return isDisabled;
    },
    checkMenuEditFileRepository(params) {
        var isDisabled = false;
        var selectedRows = params.api.getSelectedRows();

        if (selectedRows.length > 1)
            isDisabled = true;
        else {
            var selected = params.api.getFocusedCell();
            var selectedRow = params.api.getRowNode(selected.rowIndex);
            if (selectedRow.data.IsDeployed == false)
                isDisabled = false
            else
                isDisabled = true;
        }

        return isDisabled;
    },
    checkMenuDeleteFileRepository(params) {
        var isDisabled = false;
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();

        if (selectedRows.length != 0) {
            var selected = params.api.getFocusedCell();
            var selectedRow = params.api.getRowNode(selected.rowIndex);
            selectedRows.forEach(function (selectedRow, index) {
                selectedReeferData.push(selectedRow);
            });
        }

        var selectedDeployedCount = 0;
        $.each(selectedReeferData, function (index, item) {
            if (item.IsDeployed == false) {
                selectedDeployedCount++;
            }
        });

        if (selectedDeployedCount == selectedReeferData.length) {
            isDisabled = false;
        }
        else {
            isDisabled = true;
        }

        return isDisabled;
    },
    checkMenuItemVisibilityForPTWidget: (rightId: string, params, cmdStr) => {
        var tripWISEReport;
        tripWISEReport = JSON.parse(sessionStorage.getItem('customerDetails')).TripWISEreport;
        var visibilitySetting = [];
        var hide = false;
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });

        var isCT4AndLynkFound = 0;

        $.each(selectedReeferData, function (i, val)
        {
            if (val.DeviceType != null && val.DeviceType != undefined) {
                if (val.DeviceType.toString().trim() == 'CT4000' || val.DeviceType.toString().trim() == 'TripLINK') {
                    isCT4AndLynkFound = isCT4AndLynkFound + 1;
                }
            }
        });

        if (isCT4AndLynkFound > 0) {
            var eligibleTWReportForShowHide = ['ShowTripWISEReport'];
            if (eligibleTWReportForShowHide.indexOf(cmdStr) !== -1) {
                if (tripWISEReport == true)
                    hide = false;
                else
                    hide = true;
            }
        }


        if (selectedReeferData.length > 1) {

            var eligibleForHide = ['ShowTripWISEReport']
            if (eligibleForHide.indexOf(cmdStr) !== -1) {
                hide = true;
            }
        }
        else {
            if (!(isCT4AndLynkFound > 0)) {
                var eligibleForHide = ['ShowTripWISEReport']
                if (eligibleForHide.indexOf(cmdStr) !== -1) {
                    hide = true;
                }
            }
        }

        var userRights: any = sessionStorage.getItem('userRights');
        var rights = JSON.parse(userRights);
        if (rights != null && rights != undefined) {
            var rightValue = [parseInt(rightId)];
            var isValueExits = $.inArray(rightValue.toString(), rights);
            if (isValueExits == -1) {
                visibilitySetting.push('hidden');
            }
            if (isValueExits != -1 && hide) {
                visibilitySetting.push('hidden');
            }
        }

        return visibilitySetting;
    },

}

export default userRights;